





// import React, { useState, useEffect } from 'react';
// import {
//     Modal,
//     Box,
//     Typography,
//     Button,
//     TextField,
//     Grid,
//     Stack,
//     FormControl,
//     InputLabel,
//     Select,
//     MenuItem,
//     Autocomplete,
//     Alert,
//     Chip,
//     ListItem,
//     ListItemText,
//     Checkbox,
//     FormGroup,
//     FormControlLabel,
//     Divider,
//     Tooltip,
//     RadioGroup,
//     Radio,
//     FormLabel,
//     Paper,
//     Card,
//     CardContent,
//     IconButton,
//     Dialog,
//     DialogTitle,
//     DialogContent,
//     DialogActions,
//     List,
//     ListItemButton,
//     ListItemAvatar,
//     Avatar,
//     InputAdornment,
//     Pagination,
//     CircularProgress,
//     Badge,
//     Tabs,
//     Tab,
//     Slider,
//     FormGroup as MuiFormGroup,
//     Switch,
//     Accordion,
//     AccordionSummary,
//     AccordionDetails,
//     Chip as MuiChip,
//     Fade,
//     Grow,
//     Zoom,
//     useTheme,
//     CardMedia,
//     CardActionArea,
//     CardHeader,
//     CardActions,
//     Collapse
// } from '@mui/material';
// import { LocalizationProvider } from '@mui/x-date-pickers';
// import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
// import { fetchAllUsers } from 'helpers/user_helper';
// import { fetchAllCourses } from 'helpers/course_helper';
// import { generatePresignedUrlForAccess } from 'helpers/Content_helper';
// import { format, parseISO, addDays, isBefore, isToday, startOfDay, differenceInDays } from 'date-fns';
// import DOMPurify from 'dompurify';
// import InfoIcon from '@mui/icons-material/Info';
// import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
// import PersonIcon from '@mui/icons-material/Person';
// import EmailIcon from '@mui/icons-material/Email';
// import PhoneIcon from '@mui/icons-material/Phone';
// import BusinessIcon from '@mui/icons-material/Business';
// import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
// import AccessTimeIcon from '@mui/icons-material/AccessTime';
// import RefreshIcon from '@mui/icons-material/Refresh';
// import CorporateFareIcon from '@mui/icons-material/CorporateFare';
// import SchoolIcon from '@mui/icons-material/School';
// import LocalLibraryIcon from '@mui/icons-material/LocalLibrary';
// import ScheduleIcon from '@mui/icons-material/Schedule';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import SearchIcon from '@mui/icons-material/Search';
// import CloseIcon from '@mui/icons-material/Close';
// import BookIcon from '@mui/icons-material/Book';
// import MenuBookIcon from '@mui/icons-material/MenuBook';
// import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import FilterListIcon from '@mui/icons-material/FilterList';
// import SortIcon from '@mui/icons-material/Sort';
// import ViewListIcon from '@mui/icons-material/ViewList';
// import ViewModuleIcon from '@mui/icons-material/ViewModule';
// import GridViewIcon from '@mui/icons-material/GridView';
// import ClearIcon from '@mui/icons-material/Clear';
// import DoneAllIcon from '@mui/icons-material/DoneAll';
// import CategoryIcon from '@mui/icons-material/Category';
// import StarIcon from '@mui/icons-material/Star';
// import TrendingUpIcon from '@mui/icons-material/TrendingUp';
// import LanguageIcon from '@mui/icons-material/Language';
// import TimerIcon from '@mui/icons-material/Timer';
// import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
// import DriveEtaIcon from '@mui/icons-material/DriveEta';
// import BuildIcon from '@mui/icons-material/Build';
// import AssessmentIcon from '@mui/icons-material/Assessment';
// import LocalOfferIcon from '@mui/icons-material/LocalOffer';
// import LevelIcon from '@mui/icons-material/FormatListNumbered';
// import DescriptionIcon from '@mui/icons-material/Description';

// const style = {
//     position: 'absolute',
//     top: '50%',
//     left: '50%',
//     transform: 'translate(-50%, -50%)',
//     width: 950,
//     bgcolor: 'background.paper',
//     border: '2px solid #000',
//     boxShadow: 24,
//     p: 4,
//     maxHeight: '90vh',
//     overflowY: 'auto',
// };

// // Generate all time slots from 12 AM to 11 PM (24-hour format)
// const generateAllTimeSlots = () => {
//     const slots = [];
    
//     for (let duration = 1; duration <= 24; duration++) {
//         for (let hour = 0; hour <= 24 - duration; hour++) {
//             const startHour24 = hour;
//             const endHour24 = hour + duration;
            
//             const startTime24 = `${startHour24.toString().padStart(2, '0')}:00`;
//             const endTime24 = `${endHour24.toString().padStart(2, '0')}:00`;
            
//             const startHour12 = startHour24 % 12 || 12;
//             const startAmPm = startHour24 < 12 ? 'AM' : 'PM';
//             const endHour12 = endHour24 % 12 || 12;
//             const endAmPm = endHour24 < 12 ? 'AM' : 'PM';
            
//             const startDisplay = `${startHour12}:00 ${startAmPm}`;
//             const endDisplay = `${endHour12}:00 ${endAmPm}`;
            
//             slots.push({
//                 id: `${duration}-${startHour24}`,
//                 duration: duration,
//                 startHour: startHour24,
//                 endHour: endHour24,
//                 startTime: startTime24,
//                 endTime: endTime24,
//                 displayLabel: `${duration} hour${duration > 1 ? 's' : ''}: ${startDisplay} - ${endDisplay} (${startTime24} - ${endTime24} 24h)`,
//                 shortLabel: `${startDisplay} - ${endDisplay}`,
//                 timeRange: `${startDisplay} - ${endDisplay}`,
//                 startHour12: startHour12,
//                 startAmPm: startAmPm,
//                 endHour12: endHour12,
//                 endAmPm: endAmPm,
//                 startTime24: startTime24,
//                 endTime24: endTime24
//             });
//         }
//     }
//     return slots;
// };

// const timeRanges = [
//     { id: 'midnight_early', label: '🌙 Midnight to Early Morning (00:00 - 06:00)', minHour: 0, maxHour: 6, icon: '🌙' },
//     { id: 'early_morning', label: '🌅 Early Morning (06:00 - 09:00)', minHour: 6, maxHour: 9, icon: '🌅' },
//     { id: 'morning', label: '☀️ Morning (09:00 - 12:00)', minHour: 9, maxHour: 12, icon: '☀️' },
//     { id: 'afternoon', label: '☀️ Afternoon (12:00 - 15:00)', minHour: 12, maxHour: 15, icon: '☀️' },
//     { id: 'late_afternoon', label: '🌤️ Late Afternoon (15:00 - 18:00)', minHour: 15, maxHour: 18, icon: '🌤️' },
//     { id: 'evening', label: '🌆 Evening (18:00 - 21:00)', minHour: 18, maxHour: 21, icon: '🌆' },
//     { id: 'night', label: '🌙 Night (21:00 - 00:00)', minHour: 21, maxHour: 24, icon: '🌙' },
//     { id: 'full_day', label: '📅 Full Day (00:00 - 23:00)', minHour: 0, maxHour: 24, icon: '📅' },
//     { id: 'business_hours', label: '💼 Business Hours (09:00 - 18:00)', minHour: 9, maxHour: 18, icon: '💼' },
//     { id: 'flexible', label: '🕐 Flexible (Custom Range)', minHour: 0, maxHour: 24, icon: '🕐', isCustom: true },
// ];

// const formatUsers = (users) => {
//     if (!users || !Array.isArray(users)) return [];
    
//     return users.map(user => ({
//         id: user.id || user.userId,
//         name: user.name || user.username,
//         email: user.email,
//         mobile: user.mobile || user.phone,
//         userType: user.userTypeDto?.name || user.userType || '',
//         department: user.department || '',
//         role: user.role || 'User',
//         isActive: user.isActive !== undefined ? user.isActive : true
//     }));
// };

// const getUserInfo = () => {
//     try {
//         const userStr = localStorage.getItem('user');
//         if (userStr) {
//             return JSON.parse(userStr);
//         }
//     } catch (error) {
//         console.error('Error parsing user info:', error);
//     }
//     return null;
// };

// // Helper function to get level order
// const getLevelOrder = (level) => {
//     if (!level) return 999;
//     const num = parseInt(level.replace('Level ', ''));
//     return isNaN(num) ? 999 : num;
// };

// // Helper function to get level display name
// const getLevelDisplayName = (level) => {
//     if (!level) return 'N/A';
//     if (level.toLowerCase().includes('level')) {
//         return level;
//     }
//     return `Level ${level}`;
// };

// // Helper function to safely render HTML content
// const sanitizeHTML = (html) => {
//     if (!html) return '';
//     return DOMPurify.sanitize(html, {
//         ALLOWED_TAGS: ['p', 'br', 'strong', 'b', 'em', 'i', 'u', 'ul', 'ol', 'li', 'span', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
//         ALLOWED_ATTR: ['class', 'style']
//     });
// };

// // Group courses by level
// const groupCoursesByLevel = (courses) => {
//     const groups = {};
//     courses.forEach(course => {
//         const level = course.level || 'Uncategorized';
//         if (!groups[level]) {
//             groups[level] = [];
//         }
//         groups[level].push(course);
//     });
    
//     // Sort levels (Level 1, Level 2, Level 3, etc.)
//     const sortedKeys = Object.keys(groups).sort((a, b) => {
//         const aNum = getLevelOrder(a);
//         const bNum = getLevelOrder(b);
//         if (aNum !== bNum) return aNum - bNum;
//         return a.localeCompare(b);
//     });
    
//     const sortedGroups = {};
//     sortedKeys.forEach(key => {
//         // Sort courses within each level by title
//         sortedGroups[key] = groups[key].sort((a, b) => {
//             const titleA = String(a?.title || '').toLowerCase();
//             const titleB = String(b?.title || '').toLowerCase();
//             return titleA.localeCompare(titleB);
//         });
//     });
    
//     return sortedGroups;
// };

// const CreateTrainingModal = ({ isOpen, onClose, onCreateTraining, allBatch, allTrainers, allCourseNames = [], loader, organizationId, userType }) => {
//     const userInfo = getUserInfo();
//     const orgId = organizationId || userInfo?.orgId || 0;
//     const currentUserType = userType || userInfo?.userType || '';
    
//     const isOrg1 = orgId === 1;
//     const isAdmin = currentUserType?.toLowerCase() === 'admin';
//     const showOrg1Options = isOrg1 || isAdmin;
    
//     const [trainingData, setTrainingData] = useState({
//         name: '',
//         depot: '',
//         type: '',
//         trainingMode: '', // Added: Online/Offline
//         batchPlan: 20, // Added: digit plan number with default 20
//         technicalAssessmentType: '',
//         state: '',
//         trainingStartDate: '',
//         selectedTimeSlot: null,
//         trainingEndDate: '',
//         trainerId: null,
//         trainingDays: '',
//         manualEndDate: '',
//         selectedDaysOfWeek: [],
//         allowPreviousDates: true,
//         selectedTimeMode: 'preset',
//         selectedTimeRange: 'business_hours',
//         customStartHour: 9,
//         customStartMinute: 0,
//         customStartAmPm: 'AM',
//         customEndHour: 5,
//         customEndMinute: 0,
//         customEndAmPm: 'PM',
//         customRangeMinHour: 0,
//         customRangeMaxHour: 24,
//         use24HourFormat: true,
//     });

//     const [allUsers, setAllUsers] = useState([]);
//     const [loadingUsers, setLoadingUsers] = useState(false);
//     const [calculatedEndDate, setCalculatedEndDate] = useState('');
//     const [actualTrainingDays, setActualTrainingDays] = useState(0);
//     const [allTrainingDates, setAllTrainingDates] = useState([]);
//     const [formErrors, setFormErrors] = useState({});
//     const [selectedDuration, setSelectedDuration] = useState(null);
//     const [isManualDateSelection, setIsManualDateSelection] = useState(false);
//     const [selectedTrainerInfo, setSelectedTrainerInfo] = useState(null);
//     const [availableTimeSlots, setAvailableTimeSlots] = useState([]);
//     const [allTimeSlots] = useState(generateAllTimeSlots());
    
//     // Course selection popup states
//     const [isCoursePopupOpen, setIsCoursePopupOpen] = useState(false);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [selectedCourse, setSelectedCourse] = useState(null);
//     const [page, setPage] = useState(1);
//     const [coursesPerPage] = useState(9);
//     const [isLoadingCourses, setIsLoadingCourses] = useState(false);
//     const [viewMode, setViewMode] = useState('grid');
    
//     // Filter states
//     const [filters, setFilters] = useState({
//         category: '',
//         level: '',
//         language: '',
//         type: '',
//         sortBy: 'title',
//         sortOrder: 'asc',
//         showScorm: false
//     });

//     // Course data states
//     const [allCourses, setAllCourses] = useState([]);
//     const [filteredCourses, setFilteredCourses] = useState([]);
//     const [expandedLevels, setExpandedLevels] = useState({});

//     // Training mode options
//     const trainingModeOptions = [
//         { id: 'Internal', label: ' Internal', value: 'Internal' },
//         { id: 'External', label: ' External', value: 'External' }
//     ];

//     // Fetch courses from API
//     useEffect(() => {
//         if (isOpen) {
//             fetchCourses();
//         }
//     }, [isOpen]);

//     const fetchCourses = async () => {
//         try {
//             setIsLoadingCourses(true);
//             const data = await fetchAllCourses();
//             if (data?.success) {
//                 const coursesWithThumbnails = await updateThumbnails(data?.result || []);
//                 setAllCourses(coursesWithThumbnails);
//                 setFilteredCourses(coursesWithThumbnails);
//             } else {
//                 console.error('Failed to fetch courses:', data?.message);
//             }
//         } catch (error) {
//             console.error('Error fetching courses:', error);
//         } finally {
//             setIsLoadingCourses(false);
//         }
//     };

//     const updateThumbnails = async (courses) => {
//         if (!courses || courses.length === 0) return courses;
        
//         try {
//             const updatedCourses = await Promise.all(
//                 courses.map(async (course) => {
//                     if (course?.thumbnailName) {
//                         const response = await generatePresignedUrlForAccess({ 
//                             name: course.thumbnailName, 
//                             type: "image" 
//                         });
//                         if (response?.success) {
//                             return {
//                                 ...course,
//                                 thumbnailUrl: response.presignedUrl,
//                                 image: response.presignedUrl
//                             };
//                         }
//                     }
//                     // Set default image if no thumbnail
//                     return {
//                         ...course,
//                         thumbnailUrl: '/images/default-course.jpg',
//                         image: '/images/default-course.jpg'
//                     };
//                 })
//             );
//             return updatedCourses;
//         } catch (error) {
//             console.error('Error updating thumbnails:', error);
//             return courses.map(course => ({
//                 ...course,
//                 thumbnailUrl: '/images/default-course.jpg',
//                 image: '/images/default-course.jpg'
//             }));
//         }
//     };

//     // Filter and sort courses with level-wise grouping
//     const filteredAndSortedCourses = React.useMemo(() => {
//         let result = [...allCourses];
        
//         // Search filter
//         if (searchTerm) {
//             const term = searchTerm.toLowerCase();
//             result = result.filter(course => {
//                 const title = String(course?.title || '').toLowerCase();
//                 const desc = String(course?.description || '').toLowerCase();
//                 const category = String(course?.category || '').toLowerCase();
//                 const level = String(course?.level || '').toLowerCase();
//                 return title.includes(term) || desc.includes(term) || category.includes(term) || level.includes(term);
//             });
//         }
        
//         // Category filter
//         if (filters.category) {
//             result = result.filter(course => 
//                 String(course?.category || '').toLowerCase() === filters.category.toLowerCase()
//             );
//         }
        
//         // Type filter
//         if (filters.type) {
//             result = result.filter(course => 
//                 String(course?.type || '').toLowerCase() === filters.type.toLowerCase()
//             );
//         }
        
//         // Level filter
//         if (filters.level) {
//             result = result.filter(course => 
//                 String(course?.level || '').toLowerCase() === filters.level.toLowerCase()
//             );
//         }
        
//         // Language filter
//         if (filters.language) {
//             result = result.filter(course => {
//                 const lang = String(course?.language || '').toLowerCase();
//                 return lang.includes(filters.language.toLowerCase());
//             });
//         }
        
//         // Sort by level first
//         result.sort((a, b) => {
//             const levelA = getLevelOrder(a.level);
//             const levelB = getLevelOrder(b.level);
//             if (levelA !== levelB) return levelA - levelB;
            
//             const titleA = String(a?.title || '').toLowerCase();
//             const titleB = String(b?.title || '').toLowerCase();
//             return titleA.localeCompare(titleB);
//         });
        
//         return result;
//     }, [allCourses, searchTerm, filters]);

//     // Group filtered courses by level
//     const groupedCourses = React.useMemo(() => {
//         return groupCoursesByLevel(filteredAndSortedCourses);
//     }, [filteredAndSortedCourses]);

//     // Get all available levels from filtered courses
//     const availableLevels = React.useMemo(() => {
//         const levels = new Set();
//         filteredAndSortedCourses.forEach(course => {
//             if (course.level) levels.add(course.level);
//         });
//         return Array.from(levels).sort((a, b) => {
//             const aNum = getLevelOrder(a);
//             const bNum = getLevelOrder(b);
//             return aNum - bNum;
//         });
//     }, [filteredAndSortedCourses]);

//     // Get unique filter options
//     const filterOptions = React.useMemo(() => {
//         const categories = new Set();
//         const levels = new Set();
//         const languages = new Set();
//         const types = new Set();
        
//         allCourses.forEach(course => {
//             if (course.category) categories.add(course.category);
//             if (course.level) levels.add(course.level);
//             if (course.language) {
//                 course.language.split('/').forEach(lang => {
//                     languages.add(lang.trim());
//                 });
//             }
//             if (course.type) types.add(course.type);
//         });
        
//         return {
//             categories: Array.from(categories),
//             levels: Array.from(levels).sort((a, b) => {
//                 const aNum = getLevelOrder(a);
//                 const bNum = getLevelOrder(b);
//                 return aNum - bNum;
//             }),
//             languages: Array.from(languages),
//             types: Array.from(types)
//         };
//     }, [allCourses]);

//     // Toggle expanded level
//     const toggleLevelExpanded = (level) => {
//         setExpandedLevels(prev => ({
//             ...prev,
//             [level]: !prev[level]
//         }));
//     };

//     // Get courses for a specific level with pagination
//     const getLevelCourses = (level) => {
//         const courses = groupedCourses[level] || [];
//         const isExpanded = expandedLevels[level] || false;
//         const defaultShow = 9;
        
//         if (isExpanded) {
//             return courses;
//         }
//         return courses.slice(0, defaultShow);
//     };

//     // Check if level has more courses than default show
//     const hasMoreCourses = (level) => {
//         const courses = groupedCourses[level] || [];
//         return courses.length > 9;
//     };

//     // Get level color
//     const getLevelColor = (level) => {
//         if (!level) return '#6c757d';
//         const num = getLevelOrder(level);
//         if (num === 1) return '#28a745';
//         if (num === 2) return '#ffc107';
//         if (num === 3) return '#fd7e14';
//         if (num === 4) return '#dc3545';
//         if (num === 5) return '#6f42c1';
//         return '#6c757d';
//     };

//     // Get level badge color
//     const getLevelBadgeColor = (level) => {
//         if (!level) return '#6c757d';
//         const num = getLevelOrder(level);
//         if (num === 1) return '#28a745';
//         if (num === 2) return '#ffc107';
//         if (num === 3) return '#fd7e14';
//         if (num === 4) return '#dc3545';
//         if (num === 5) return '#6f42c1';
//         return '#6c757d';
//     };

//     const defaultStateData = [
//         { id: 1, name: "Ahmedabad" },
//         { id: 2, name: "Bangalore" },
//         { id: 3, name: "Delhi" },
//         { id: 4, name: "Jammu" },
//         { id: 5, name: "Jamshedpur" },
//         { id: 6, name: "Mumbai" },
//         { id: 7, name: "Odisha" },
//         { id: 8, name: "Srinagar" },
//         { id: 9, name: "Uttarakhand" },
//         { id: 10, name: "Online" },
//     ];

//     const org1StateData = [{ id: 1, name: "Online" }];
//     const stateData = showOrg1Options ? org1StateData : defaultStateData;

//     const defaultDepotMapping = {
//         Ahmedabad: ["BBM", "Naranpura", "Online"],
//         Bangalore: ["Jayanagar", "Hennur", "Peenya", "Shanti Nagar", "Deepanjali Nagar", "Jigani", "Kannalli", "K R Puram", "Online","Vaddarahalli","Traffic Management Centre (TMC)"],
//         Delhi: ["BBM", "Hasanpur", "Mayapuri", "Naraina", "Kalkaji", "Sukhdev Vihar", "Nehru Place", "Mundela Kalan", "Rohini-1", "Rohini-2", "Subhash Place", "Wazirpur", "Nand Nagri", "Indraprastha", "TSS", "Online"],
//         Jammu: ["Bhagwati Nagar", "Online"],
//         Jamshedpur: ["Mera Mandali", "Online"],
//         Mumbai: ["Worli", "Malwani", "Shivaji Nagar", "Backbay", "Online"],
//         Odisha: ["Kalinga Nagar", "Online"],
//         Srinagar: ["Pantha Chowk", "Online"],
//         Uttarakhand: ["Pantnagar", "Online"],
//         Online: ["Online"]
//     };

//     const org1DepotMapping = { Online: ["Online"] };
//     const depotMapping = showOrg1Options ? org1DepotMapping : defaultDepotMapping;

//     const defaultTypeData = [
//         { id: 1, name: "Safety" },
//         { id: 2, name: "IT" },
//         { id: 3, name: "Technical" },
//         { id: 4, name: "Driver" },
//     ];

//     const org1TypeData = [
//         { id: 1, name: "Skilling", icon: <SchoolIcon sx={{ ml: 1, fontSize: '1rem', color: 'primary.main' }} /> },
//         { id: 2, name: "Upskilling", icon: <LocalLibraryIcon sx={{ ml: 1, fontSize: '1rem', color: 'success.main' }} /> },
//         { id: 3, name: "Paid Trainings", icon: <BusinessIcon sx={{ ml: 1, fontSize: '1rem', color: 'warning.main' }} /> },
//         { id: 4, name: "Corporate", icon: <CorporateFareIcon sx={{ ml: 1, fontSize: '1rem', color: 'info.main' }} /> },
//         { id: 5, name: "School Project", icon: <SchoolIcon sx={{ ml: 1, fontSize: '1rem', color: 'secondary.main' }} /> },
//         { id: 6, name: "University & College", icon: <LocalLibraryIcon sx={{ ml: 1, fontSize: '1rem', color: 'primary.main' }} /> },
//         { id: 7, name: "Skill Development", icon: <WorkspacePremiumIcon sx={{ ml: 1, fontSize: '1rem', color: 'success.main' }} /> },
//     ];

//     const typeData = showOrg1Options ? org1TypeData : defaultTypeData;

//     const assessmentTypeData = [
//         { id: 'bronze', name: 'Bronze', color: '#CD7F32', description: 'Basic technical skills assessment', icon: '🥉', fullName: 'Bronze Assessment', requirements: 'Post-test ≥80%, Basic technical knowledge', addToName: true },
//         { id: 'silver', name: 'Silver', color: '#C0C0C0', description: 'Intermediate technical skills assessment', icon: '🥈', fullName: 'Silver Assessment', requirements: 'Post-test ≥80%, Must pass Bronze first', addToName: true },
//         { id: 'gold', name: 'Gold', color: '#FFD700', description: 'Advanced technical skills assessment', icon: '🥇', fullName: 'Gold Assessment', requirements: 'Post-test ≥80%, Must pass Silver first', addToName: true },
//         { id: 'other', name: 'Other', color: '#9E9E9E', description: 'Other assessment type', icon: '📋', fullName: 'Other Assessment', requirements: 'Custom assessment criteria', addToName: false }
//     ];

//     const daysOfWeek = [
//         { id: 0, name: 'Sunday', short: 'Sun' },
//         { id: 1, name: 'Monday', short: 'Mon' },
//         { id: 2, name: 'Tuesday', short: 'Tue' },
//         { id: 3, name: 'Wednesday', short: 'Wed' },
//         { id: 4, name: 'Thursday', short: 'Thu' },
//         { id: 5, name: 'Friday', short: 'Fri' },
//         { id: 6, name: 'Saturday', short: 'Sat' },
//     ];

//     const depotsForState = trainingData.state ? depotMapping[trainingData.state] || ["Online"] : [];
//     const trainingDayOptions = [1, 2, 3, 6];
//     const isTechnicalTraining = !showOrg1Options && trainingData.type === 'Technical';
//     const selectedAssessment = assessmentTypeData.find(a => a.name === trainingData.technicalAssessmentType);
//     const shouldAddAssessmentToName = selectedAssessment?.addToName !== false;

//     const formatTimeForDisplay = (time24) => {
//         if (!time24) return '';
//         if (trainingData.use24HourFormat) {
//             return time24;
//         }
//         const [hours, minutes] = time24.split(':');
//         const hour = parseInt(hours);
//         const ampm = hour >= 12 ? 'PM' : 'AM';
//         const hour12 = hour % 12 || 12;
//         return `${hour12}:${minutes} ${ampm}`;
//     };

//     const convertTo24Hour = (hour, minute, ampm) => {
//         let hour24 = hour;
//         if (ampm === 'PM' && hour !== 12) hour24 = hour + 12;
//         else if (ampm === 'AM' && hour === 12) hour24 = 0;
//         return { hour: hour24, minute };
//     };

//     // Filter time slots based on mode
//     useEffect(() => {
//         if (!selectedDuration) {
//             setAvailableTimeSlots([]);
//             return;
//         }

//         let filteredSlots = allTimeSlots.filter(slot => slot.duration === selectedDuration);

//         if (trainingData.selectedTimeMode === 'preset') {
//             setAvailableTimeSlots(filteredSlots);
//         } 
//         else if (trainingData.selectedTimeMode === 'range') {
//             const range = timeRanges.find(r => r.id === trainingData.selectedTimeRange);
//             if (range && !range.isCustom) {
//                 filteredSlots = filteredSlots.filter(slot => 
//                     slot.startHour >= range.minHour && slot.endHour <= range.maxHour
//                 );
//                 setAvailableTimeSlots(filteredSlots);
//             } else if (range && range.isCustom) {
//                 filteredSlots = filteredSlots.filter(slot => 
//                     slot.startHour >= trainingData.customRangeMinHour && 
//                     slot.endHour <= trainingData.customRangeMaxHour
//                 );
//                 setAvailableTimeSlots(filteredSlots);
//             }
//         }
//         else if (trainingData.selectedTimeMode === 'custom') {
//             const start24 = convertTo24Hour(trainingData.customStartHour, trainingData.customStartMinute, trainingData.customStartAmPm);
//             const end24 = convertTo24Hour(trainingData.customEndHour, trainingData.customEndMinute, trainingData.customEndAmPm);
            
//             filteredSlots = filteredSlots.filter(slot => 
//                 slot.startHour >= start24.hour && slot.endHour <= end24.hour
//             );
//             setAvailableTimeSlots(filteredSlots);
//         }
//     }, [selectedDuration, trainingData.selectedTimeMode, trainingData.selectedTimeRange, trainingData.customStartHour, trainingData.customStartMinute, trainingData.customStartAmPm, trainingData.customEndHour, trainingData.customEndMinute, trainingData.customEndAmPm, trainingData.customRangeMinHour, trainingData.customRangeMaxHour, allTimeSlots]);

//     // Fetch all users
//     useEffect(() => {
//         const loadAllUsers = async () => {
//             if (!isOpen) return;
//             setLoadingUsers(true);
//             try {
//                 const response = await fetchAllUsers();
//                 const usersArray = response?.result || response || [];
//                 const formattedUsers = formatUsers(usersArray);
//                 setAllUsers(formattedUsers);
//             } catch (error) {
//                 console.error('Error loading users:', error);
//             } finally {
//                 setLoadingUsers(false);
//             }
//         };
//         loadAllUsers();
//     }, [isOpen]);

//     // Auto-select Online state and depot
//     useEffect(() => {
//         if (showOrg1Options && isOpen) {
//             setTrainingData(prev => ({ ...prev, state: "Online", depot: "Online" }));
//         }
//     }, [showOrg1Options, isOpen]);

//     // Calculate training dates for fixed days
//     const calculateFixedDates = (startDate, days, timeSlot, selectedDays = []) => {
//         if (!startDate || !days || !timeSlot) return { endDate: '', actualTrainingDays: 0, allDates: [] };
        
//         try {
//             let start = parseISO(startDate);
//             if (isNaN(start.getTime())) return { endDate: '', actualTrainingDays: 0, allDates: [] };
            
//             const allDates = [];
//             let trainingDaysCount = 0;
//             let currentDate = new Date(start);
//             let maxDate = new Date(start);
            
//             if (selectedDays.length > 0) {
//                 let dayIndex = 0;
//                 while (trainingDaysCount < days) {
//                     const currentDayOfWeek = currentDate.getDay();
//                     if (selectedDays.includes(currentDayOfWeek)) {
//                         const trainingDate = new Date(currentDate);
//                         trainingDate.setHours(timeSlot.startHour, 0);
//                         allDates.push({
//                             date: new Date(trainingDate),
//                             dayOfWeek: format(trainingDate, 'EEEE'),
//                             startTime: timeSlot.startTime,
//                             endTime: timeSlot.endTime,
//                             duration: timeSlot.duration,
//                             isTrainingDay: true
//                         });
//                         trainingDaysCount++;
//                         if (trainingDate > maxDate) maxDate = new Date(trainingDate);
//                     }
//                     currentDate.setDate(currentDate.getDate() + 1);
//                     if (dayIndex > 365) break;
//                     dayIndex++;
//                 }
//                 maxDate.setHours(timeSlot.endHour, 0);
//                 const year = maxDate.getFullYear();
//                 const month = String(maxDate.getMonth() + 1).padStart(2, '0');
//                 const day = String(maxDate.getDate()).padStart(2, '0');
//                 return { endDate: `${year}-${month}-${day}`, actualTrainingDays: trainingDaysCount, allDates: allDates };
//             }
            
//             for (let i = 0; i < days; i++) {
//                 const trainingDate = new Date(start);
//                 trainingDate.setDate(start.getDate() + i);
//                 trainingDate.setHours(timeSlot.startHour, 0);
//                 allDates.push({
//                     date: new Date(trainingDate),
//                     dayOfWeek: format(trainingDate, 'EEEE'),
//                     startTime: timeSlot.startTime,
//                     endTime: timeSlot.endTime,
//                     duration: timeSlot.duration,
//                     isTrainingDay: true
//                 });
//             }
            
//             const endDate = new Date(start);
//             endDate.setDate(start.getDate() + days - 1);
//             endDate.setHours(timeSlot.endHour, 0);
//             const year = endDate.getFullYear();
//             const month = String(endDate.getMonth() + 1).padStart(2, '0');
//             const day = String(endDate.getDate()).padStart(2, '0');
//             return { endDate: `${year}-${month}-${day}`, actualTrainingDays: days, allDates: allDates };
//         } catch (e) {
//             console.error("Error calculating fixed dates:", e);
//             return { endDate: '', actualTrainingDays: 0, allDates: [] };
//         }
//     };

//     // Calculate training dates for manual range
//     const calculateManualDates = (startDate, endDate, timeSlot, selectedDays = []) => {
//         if (!startDate || !endDate || !timeSlot) return { actualTrainingDays: 0, allDates: [] };
        
//         try {
//             const start = parseISO(startDate);
//             const end = parseISO(endDate);
//             if (isNaN(start.getTime()) || isNaN(end.getTime()) || start > end) {
//                 return { actualTrainingDays: 0, allDates: [] };
//             }
            
//             let current = new Date(start);
//             const allDates = [];
//             let trainingDaysCount = 0;
            
//             while (current <= end) {
//                 const currentDay = new Date(current);
//                 const currentDayOfWeek = currentDay.getDay();
                
//                 if (selectedDays.length === 0 || selectedDays.includes(currentDayOfWeek)) {
//                     currentDay.setHours(timeSlot.startHour, 0);
//                     trainingDaysCount++;
//                     allDates.push({
//                         date: new Date(currentDay),
//                         dayOfWeek: format(currentDay, 'EEEE'),
//                         isTrainingDay: true,
//                         startTime: timeSlot.startTime,
//                         endTime: timeSlot.endTime,
//                         duration: timeSlot.duration
//                     });
//                 }
//                 current.setDate(current.getDate() + 1);
//             }
//             return { actualTrainingDays: trainingDaysCount, allDates: allDates };
//         } catch (e) {
//             console.error("Error calculating manual dates:", e);
//             return { actualTrainingDays: 0, allDates: [] };
//         }
//     };

//     // Update calculations when inputs change
//     useEffect(() => {
//         if (isManualDateSelection) {
//             // Manual date selection mode
//             if (trainingData.trainingStartDate && trainingData.manualEndDate && trainingData.selectedTimeSlot) {
//                 const { actualTrainingDays, allDates } = calculateManualDates(
//                     trainingData.trainingStartDate,
//                     trainingData.manualEndDate,
//                     trainingData.selectedTimeSlot,
//                     trainingData.selectedDaysOfWeek
//                 );
//                 setActualTrainingDays(actualTrainingDays);
//                 setAllTrainingDates(allDates);
//                 setCalculatedEndDate(trainingData.manualEndDate);
//             } else {
//                 setActualTrainingDays(0);
//                 setAllTrainingDates([]);
//                 setCalculatedEndDate('');
//             }
//         } else {
//             // Fixed days mode
//             if (trainingData.trainingStartDate && trainingData.trainingDays && trainingData.selectedTimeSlot && trainingData.trainingDays !== "0") {
//                 const { endDate, actualTrainingDays, allDates } = calculateFixedDates(
//                     trainingData.trainingStartDate,
//                     parseInt(trainingData.trainingDays),
//                     trainingData.selectedTimeSlot,
//                     trainingData.selectedDaysOfWeek
//                 );
//                 setCalculatedEndDate(endDate);
//                 setActualTrainingDays(actualTrainingDays);
//                 setAllTrainingDates(allDates);
//             } else {
//                 setCalculatedEndDate('');
//                 setActualTrainingDays(0);
//                 setAllTrainingDates([]);
//             }
//         }
//     }, [trainingData.trainingStartDate, trainingData.trainingDays, trainingData.selectedTimeSlot, trainingData.manualEndDate, trainingData.selectedDaysOfWeek, isManualDateSelection]);

//     const validateForm = () => {
//         const errors = {};
//         if (!trainingData.name) errors.name = 'Training name is required';
//         if (!trainingData.state) errors.state = 'State is required';
//         if (!trainingData.depot) errors.depot = 'Depot is required';
//         if (!trainingData.type) errors.type = 'Training type is required';
//         if (!trainingData.trainingMode) errors.trainingMode = 'Training mode is required'; // Added validation
//         if (trainingData.trainingDays === "") errors.trainingDays = 'Training days is required';
//         if (!trainingData.trainingStartDate) errors.trainingStartDate = 'Start date is required';
//         if (!selectedDuration) errors.duration = 'Duration is required';
//         if (!trainingData.selectedTimeSlot) errors.timeSlot = 'Training time slot is required';
//         if (!trainingData.trainerId) errors.trainer = 'Trainer is required';
//         if (isTechnicalTraining && !trainingData.technicalAssessmentType) errors.technicalAssessmentType = 'Assessment type is required';
//         if (isManualDateSelection && !trainingData.manualEndDate) errors.manualEndDate = 'End date is required';
//         if (!isManualDateSelection && !trainingData.trainingDays) errors.trainingDays = 'Training days is required';
//         setFormErrors(errors);
//         return Object.keys(errors).length === 0;
//     };

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         if (name === 'type') {
//             setTrainingData(prev => ({ ...prev, [name]: value, technicalAssessmentType: value === 'Technical' ? prev.technicalAssessmentType : '' }));
//         } else if (name === 'trainingDays') {
//             const isManual = value === "0";
//             setIsManualDateSelection(isManual);
//             setTrainingData(prev => ({ ...prev, [name]: value, selectedDaysOfWeek: [], manualEndDate: '' }));
//             if (isManual) {
//                 setSelectedDuration(null);
//             }
//         } else if (name === 'batchPlan') {
//             // Handle batchPlan as number with validation
//             const numValue = parseInt(value) || 0;
//             setTrainingData(prev => ({ ...prev, [name]: numValue }));
//         } else {
//             setTrainingData(prev => ({ ...prev, [name]: value }));
//         }
//         if (formErrors[name]) setFormErrors(prev => ({ ...prev, [name]: '' }));
//     };

//     const handleTimeSlotChange = (slot) => {
//         setTrainingData(prev => ({ ...prev, selectedTimeSlot: slot }));
//         if (formErrors.timeSlot) setFormErrors(prev => ({ ...prev, timeSlot: '' }));
//     };

//     const handleDurationChange = (event) => {
//         const newDuration = event.target.value;
//         setSelectedDuration(newDuration);
//         setTrainingData(prev => ({ ...prev, selectedTimeSlot: null }));
//         if (formErrors.duration) setFormErrors(prev => ({ ...prev, duration: '' }));
//     };

//     const handleTrainerChange = (event, newValue) => {
//         setTrainingData(prev => ({ ...prev, trainerId: newValue ? newValue.id : null }));
//         setSelectedTrainerInfo(newValue);
//         if (formErrors.trainer) setFormErrors(prev => ({ ...prev, trainer: '' }));
//     };

//     const handleAssessmentTypeChange = (e) => {
//         setTrainingData(prev => ({ ...prev, technicalAssessmentType: e.target.value }));
//         if (formErrors.technicalAssessmentType) setFormErrors(prev => ({ ...prev, technicalAssessmentType: '' }));
//     };

//     const handleDaysOfWeekChange = (dayId) => {
//         setTrainingData(prev => {
//             const currentDays = [...prev.selectedDaysOfWeek];
//             const index = currentDays.indexOf(dayId);
//             if (index > -1) currentDays.splice(index, 1);
//             else currentDays.push(dayId);
//             return { ...prev, selectedDaysOfWeek: currentDays };
//         });
//     };

//     const handleAllowPreviousDatesChange = (e) => {
//         setTrainingData(prev => ({ ...prev, allowPreviousDates: e.target.checked }));
//     };

//     const handleTimeModeChange = (mode) => {
//         setTrainingData(prev => ({ ...prev, selectedTimeMode: mode, selectedTimeSlot: null }));
//     };

//     const handleTimeRangeChange = (rangeId) => {
//         setTrainingData(prev => ({ ...prev, selectedTimeRange: rangeId, selectedTimeSlot: null }));
//     };

//     const handleCustomRangeChange = (type, value) => {
//         if (type === 'min') {
//             setTrainingData(prev => ({ ...prev, customRangeMinHour: value, selectedTimeSlot: null }));
//         } else {
//             setTrainingData(prev => ({ ...prev, customRangeMaxHour: value, selectedTimeSlot: null }));
//         }
//     };

//     const handleCustomStartChange = (field, value) => {
//         setTrainingData(prev => ({ ...prev, [field]: value, selectedTimeSlot: null }));
//     };

//     const handleFormatToggle = () => {
//         setTrainingData(prev => ({ ...prev, use24HourFormat: !prev.use24HourFormat }));
//     };

//     // Filter handlers
//     const handleFilterChange = (key, value) => {
//         setFilters(prev => ({ ...prev, [key]: value }));
//         setPage(1);
//         // Reset expanded levels when filters change
//         setExpandedLevels({});
//     };

//     const handleClearFilters = () => {
//         setFilters({
//             category: '',
//             level: '',
//             language: '',
//             type: '',
//             sortBy: 'title',
//             sortOrder: 'asc',
//             showScorm: false
//         });
//         setSearchTerm('');
//         setPage(1);
//         setExpandedLevels({});
//     };

//     // Course popup handlers
//     const handleOpenCoursePopup = () => {
//         setSearchTerm('');
//         setPage(1);
//         setSelectedCourse(null);
//         handleClearFilters();
//         setIsCoursePopupOpen(true);
//     };

//     const handleCloseCoursePopup = () => {
//         setIsCoursePopupOpen(false);
//         setSearchTerm('');
//         setPage(1);
//         setExpandedLevels({});
//     };

//     const handleSelectCourse = (course) => {
//         const courseName = course?.title || '';
//         setSelectedCourse(course);
//         setTrainingData(prev => ({ ...prev, name: courseName }));
//         setIsCoursePopupOpen(false);
//         setSearchTerm('');
//         setPage(1);
//         setExpandedLevels({});
//         if (formErrors.name) setFormErrors(prev => ({ ...prev, name: '' }));
//     };

//     const handleSearchChange = (event) => {
//         setSearchTerm(event.target.value);
//         setPage(1);
//         setExpandedLevels({});
//     };

//     const handleSubmit = (e) => {
//         e.preventDefault();
//         if (!validateForm()) return;
        
//         const isManual = isManualDateSelection;
//         const trainingDaysCount = isManual ? actualTrainingDays : parseInt(trainingData.trainingDays);
//         const finalEndDate = isManual ? trainingData.manualEndDate : calculatedEndDate;
//         const timeSlot = trainingData.selectedTimeSlot;
        
//         if (!finalEndDate || !timeSlot) {
//             console.error("Missing required data:", { finalEndDate, timeSlot });
//             return;
//         }
        
//         const startDate = parseISO(trainingData.trainingStartDate);
//         const today = startOfDay(new Date());
//         const isPastDate = isBefore(startDate, today) && !isToday(startDate);
        
//         const timeDisplayShort = trainingData.use24HourFormat 
//             ? `${timeSlot.startTime24 || timeSlot.startTime} - ${timeSlot.endTime24 || timeSlot.endTime}`
//             : timeSlot.shortLabel;
        
//         const concatenatedType = `${trainingData.type} - ${trainingDaysCount} Day${trainingDaysCount > 1 ? 's' : ''} - ${timeDisplayShort}`;
        
//         const assessmentInfo = selectedAssessment ? {
//             assessmentId: selectedAssessment.id,
//             assessmentName: selectedAssessment.name,
//             assessmentFullName: selectedAssessment.fullName,
//             assessmentColor: selectedAssessment.color,
//             assessmentIcon: selectedAssessment.icon,
//             addToName: selectedAssessment.addToName
//         } : null;
        
//         let batchName = trainingData.name;
//         if (isTechnicalTraining && selectedAssessment && shouldAddAssessmentToName) {
//             batchName = `${selectedAssessment.name} ${trainingData.name}`;
//         }
        
//         const dataToSend = {
//             name: batchName,
//             originalName: trainingData.name,
//             depot: trainingData.depot,
//             type: concatenatedType,
//             originalType: trainingData.type,
//             trainingMode: trainingData.trainingMode, // Added
//             batchPlan: trainingData.batchPlan, // Added
//             technicalAssessmentType: trainingData.technicalAssessmentType,
//             assessmentType: trainingData.technicalAssessmentType?.toLowerCase() || '',
//             assessmentInfo: assessmentInfo,
//             isBronzeAssessment: trainingData.technicalAssessmentType === 'Bronze',
//             isSilverAssessment: trainingData.technicalAssessmentType === 'Silver',
//             isGoldAssessment: trainingData.technicalAssessmentType === 'Gold',
//             isOtherAssessment: trainingData.technicalAssessmentType === 'Other',
//             state: trainingData.state,
//             trainingStartDate: trainingData.trainingStartDate,
//             trainingEndDate: finalEndDate,
//             trainerId: trainingData.trainerId,
//             trainerName: selectedTrainerInfo?.name || '',
//             trainerEmail: selectedTrainerInfo?.email || '',
//             trainerPhone: selectedTrainerInfo?.mobile || '',
//             trainingDays: trainingDaysCount,
//             startTime: timeSlot.startTime,
//             endTime: timeSlot.endTime,
//             duration: timeSlot.duration,
//             timeSlotLabel: timeSlot.displayLabel,
//             timeSlotShortLabel: timeDisplayShort,
//             actualTrainingDays: actualTrainingDays,
//             isManualDateSelection: isManual,
//             isTechnicalTraining: isTechnicalTraining,
//             selectedDaysOfWeek: trainingData.selectedDaysOfWeek,
//             allowPreviousDates: trainingData.allowPreviousDates,
//             isPastDate: isPastDate,
//             batchSchedule: allTrainingDates.map(d => ({
//                 date: format(d.date, 'yyyy-MM-dd'),
//                 dayOfWeek: d.dayOfWeek,
//                 startTime: d.startTime,
//                 endTime: d.endTime,
//                 duration: d.duration
//             })),
//             organizationId: orgId,
//             userType: currentUserType,
//             isOrg1: isOrg1,
//             isAdmin: isAdmin,
//             use24HourFormat: trainingData.use24HourFormat,
//             durationHours: selectedDuration,
//             courseId: selectedCourse?.id || null,
//             courseTitle: selectedCourse?.title || trainingData.name
//         };
        
//         onCreateTraining(dataToSend);
//     };

//     const resetForm = () => {
//         setTrainingData({
//             name: '', depot: '', type: '', trainingMode: '', batchPlan: 20, // Reset with default values
//             technicalAssessmentType: '', state: '', trainingStartDate: '',
//             selectedTimeSlot: null, trainingEndDate: '', trainerId: null, trainingDays: '', manualEndDate: '',
//             selectedDaysOfWeek: [], allowPreviousDates: true, selectedTimeMode: 'preset', selectedTimeRange: 'business_hours',
//             customStartHour: 9, customStartMinute: 0, customStartAmPm: 'AM', customEndHour: 5, customEndMinute: 0, customEndAmPm: 'PM',
//             customRangeMinHour: 0, customRangeMaxHour: 24, use24HourFormat: true,
//         });
//         setSelectedDuration(null);
//         setIsManualDateSelection(false);
//         setSelectedTrainerInfo(null);
//         setCalculatedEndDate('');
//         setActualTrainingDays(0);
//         setAllTrainingDates([]);
//         setFormErrors({});
//         setAvailableTimeSlots([]);
//         setSelectedCourse(null);
//         setSearchTerm('');
//         setPage(1);
//         setExpandedLevels({});
//         handleClearFilters();
//     };

//     const handleClose = () => {
//         resetForm();
//         onClose();
//     };

//     const today = new Date().toISOString().split('T')[0];

//     const refreshUsers = async () => {
//         setLoadingUsers(true);
//         try {
//             const response = await fetchAllUsers();
//             const usersArray = response?.result || response || [];
//             setAllUsers(formatUsers(usersArray));
//         } catch (error) {
//             console.error('Error refreshing users:', error);
//         } finally {
//             setLoadingUsers(false);
//         }
//     };

//     useEffect(() => {
//         if (isOpen && !trainingData.trainingStartDate) {
//             setTrainingData(prev => ({ ...prev, trainingStartDate: today }));
//         }
//     }, [isOpen]);

//     const getConcatenatedTypeMessage = () => {
//         if (!trainingData.type) return "Select training type";
//         if (!selectedDuration) return `${trainingData.type} - Select duration`;
//         const daysNum = isManualDateSelection ? actualTrainingDays : (trainingData.trainingDays === "0" ? 0 : parseInt(trainingData.trainingDays));
//         const timeDisplay = trainingData.selectedTimeSlot 
//             ? (trainingData.use24HourFormat 
//                 ? `${trainingData.selectedTimeSlot.startTime24 || trainingData.selectedTimeSlot.startTime} - ${trainingData.selectedTimeSlot.endTime24 || trainingData.selectedTimeSlot.endTime}`
//                 : trainingData.selectedTimeSlot.shortLabel)
//             : "Select time";
//         return `${trainingData.type} - ${daysNum} Day${daysNum !== 1 ? 's' : ''} - ${timeDisplay}`;
//     };

//     // Get course details for display
//     const getCourseDetails = (course) => {
//         if (!course) return null;
        
//         return {
//             title: course.title || 'Untitled Course',
//             level: course.level || 'Uncategorized',
//             category: course.category || 'Uncategorized',
//             duration: course.duration || 'N/A',
//             language: course.language || 'N/A',
//             type: course.type || 'N/A',
//             description: course.description || '',
//             rating: course.rating || null,
//             thumbnailUrl: course.thumbnailUrl || course.image || '/images/default-course.jpg',
//             id: course.id || null
//         };
//     };

//     // Render course card with proper details
//     const renderCourseCard = (course) => {
//         const isSelected = selectedCourse?.id === course.id;
//         const courseDetails = getCourseDetails(course);
        
//         // Get level color
//         const levelColor = getLevelColor(courseDetails.level);
        
//         return (
//             <Grow in={true} style={{ transitionDelay: `${(Math.random() * 300)}ms` }}>
//                 <Grid item xs={12} sm={6} md={4}>
//                     <Card 
//                         sx={{ 
//                             height: '100%',
//                             display: 'flex',
//                             flexDirection: 'column',
//                             position: 'relative',
//                             border: isSelected ? '3px solid #1976d2' : '1px solid #e0e0e0',
//                             transition: 'all 0.3s ease',
//                             '&:hover': {
//                                 transform: 'translateY(-8px)',
//                                 boxShadow: 8
//                             },
//                             cursor: 'pointer'
//                         }}
//                         onClick={() => handleSelectCourse(course)}
//                     >
//                         {/* Selection badge */}
//                         {isSelected && (
//                             <Box
//                                 sx={{
//                                     position: 'absolute',
//                                     top: 10,
//                                     right: 10,
//                                     zIndex: 1
//                                 }}
//                             >
//                                 <Chip
//                                     label="Selected"
//                                     color="primary"
//                                     size="small"
//                                     icon={<CheckCircleIcon />}
//                                 />
//                             </Box>
//                         )}
                        
//                         {/* Level Badge */}
//                         {courseDetails.level && courseDetails.level !== 'Uncategorized' && (
//                             <Box
//                                 sx={{
//                                     position: 'absolute',
//                                     top: 10,
//                                     left: 10,
//                                     zIndex: 1
//                                 }}
//                             >
//                                 <Chip
//                                     label={courseDetails.level}
//                                     size="small"
//                                     sx={{
//                                         bgcolor: levelColor,
//                                         color: 'white',
//                                         fontWeight: 'bold'
//                                     }}
//                                 />
//                             </Box>
//                         )}
                        
//                         {/* Course Image */}
//                         <CardMedia
//                             component="img"
//                             height="180"
//                             image={courseDetails.thumbnailUrl}
//                             alt={courseDetails.title}
//                             sx={{
//                                 objectFit: 'cover',
//                                 backgroundColor: '#f5f5f5'
//                             }}
//                             onError={(e) => {
//                                 e.target.src = '/images/default-course.jpg';
//                             }}
//                         />
                        
//                         <CardHeader
//                             title={
//                                 <Typography variant="subtitle1" fontWeight="bold" sx={{ 
//                                     display: '-webkit-box',
//                                     WebkitLineClamp: 2,
//                                     WebkitBoxOrient: 'vertical',
//                                     overflow: 'hidden',
//                                     fontSize: '0.95rem',
//                                     lineHeight: 1.3
//                                 }}>
//                                     {courseDetails.title}
//                                 </Typography>
//                             }
//                             subheader={
//                                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.5, flexWrap: 'wrap' }}>
//                                     <CategoryIcon sx={{ fontSize: '0.8rem', color: 'text.secondary' }} />
//                                     <Typography variant="caption" color="text.secondary">
//                                         {courseDetails.category}
//                                     </Typography>
//                                     {courseDetails.type && courseDetails.type !== 'N/A' && (
//                                         <>
//                                             <span style={{ color: '#ccc', margin: '0 4px' }}>|</span>
//                                             <Chip 
//                                                 label={courseDetails.type} 
//                                                 size="small" 
//                                                 variant="outlined" 
//                                                 sx={{ height: 18, fontSize: '0.65rem' }} 
//                                             />
//                                         </>
//                                     )}
//                                 </Box>
//                             }
//                             sx={{ pb: 0 }}
//                         />
                        
//                         <CardContent sx={{ flexGrow: 1, pt: 1 }}>
//                             {/* Course details */}
//                             <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
//                                 {courseDetails.duration && courseDetails.duration !== 'N/A' && (
//                                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                                         <TimerIcon sx={{ fontSize: '1rem', color: 'text.secondary' }} />
//                                         <Typography variant="body2" color="text.secondary">
//                                             {courseDetails.duration}
//                                         </Typography>
//                                     </Box>
//                                 )}
                                
//                                 {courseDetails.language && courseDetails.language !== 'N/A' && (
//                                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                                         <LanguageIcon sx={{ fontSize: '1rem', color: 'text.secondary' }} />
//                                         <Typography variant="body2" color="text.secondary">
//                                             {courseDetails.language}
//                                         </Typography>
//                                     </Box>
//                                 )}
                                
//                                 {courseDetails.rating && (
//                                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                                         <StarIcon sx={{ fontSize: '1rem', color: '#f5b342' }} />
//                                         <Typography variant="body2" color="text.secondary">
//                                             {courseDetails.rating} / 5.0
//                                         </Typography>
//                                     </Box>
//                                 )}
                                
//                                 {courseDetails.description && (
//                                     <Box sx={{ mt: 0.5 }}>
//                                         <Typography 
//                                             variant="caption" 
//                                             color="text.secondary" 
//                                             sx={{ 
//                                                 display: '-webkit-box',
//                                                 WebkitLineClamp: 2,
//                                                 WebkitBoxOrient: 'vertical',
//                                                 overflow: 'hidden',
//                                                 '& p': { margin: 0 }
//                                             }}
//                                             dangerouslySetInnerHTML={{ 
//                                                 __html: sanitizeHTML(courseDetails.description) 
//                                             }}
//                                         />
//                                     </Box>
//                                 )}
//                             </Box>
                            
//                             {/* Tags */}
//                             <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 1 }}>
//                                 {courseDetails.category && courseDetails.category !== 'Uncategorized' && (
//                                     <Chip 
//                                         label={courseDetails.category} 
//                                         size="small" 
//                                         variant="outlined" 
//                                         color="primary"
//                                     />
//                                 )}
//                                 {courseDetails.level && courseDetails.level !== 'Uncategorized' && (
//                                     <Chip 
//                                         label={courseDetails.level} 
//                                         size="small" 
//                                         variant="filled"
//                                         sx={{ 
//                                             bgcolor: levelColor,
//                                             color: 'white'
//                                         }}
//                                     />
//                                 )}
//                             </Box>
//                         </CardContent>
                        
//                         <CardActions sx={{ p: 2, pt: 0 }}>
//                             <Button 
//                                 fullWidth 
//                                 variant={isSelected ? "contained" : "outlined"}
//                                 color="primary"
//                                 size="small"
//                                 onClick={(e) => {
//                                     e.stopPropagation();
//                                     handleSelectCourse(course);
//                                 }}
//                                 startIcon={isSelected ? <CheckCircleIcon /> : <BookIcon />}
//                             >
//                                 {isSelected ? 'Selected' : 'Select Course'}
//                             </Button>
//                         </CardActions>
//                     </Card>
//                 </Grid>
//             </Grow>
//         );
//     };

//     return (
//         <LocalizationProvider dateAdapter={AdapterDateFns}>
//             <Modal open={isOpen} onClose={handleClose}>
//                 <Box sx={style}>
//                     <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
//                         <Typography variant="h6" component="h2">
//                             Create New Training
//                             {showOrg1Options && <Chip label="Online Mode" size="small" color="primary" sx={{ ml: 2 }} />}
//                             {isTechnicalTraining && selectedAssessment && (
//                                 <Chip label={`${selectedAssessment.icon} ${selectedAssessment.name} Assessment`} size="small" 
//                                     sx={{ ml: 2, bgcolor: selectedAssessment.color, color: selectedAssessment.name === 'Silver' ? '#000' : '#fff' }} />
//                             )}
//                         </Typography>
//                         <Tooltip title={trainingData.use24HourFormat ? "Switch to 12-hour format" : "Switch to 24-hour format"}>
//                             <Button 
//                                 size="small" 
//                                 variant="outlined" 
//                                 onClick={handleFormatToggle}
//                                 sx={{ textTransform: 'none' }}
//                             >
//                                 {trainingData.use24HourFormat ? "24h Format" : "12h Format"}
//                             </Button>
//                         </Tooltip>
//                     </Box>
                    
//                     <form onSubmit={handleSubmit}>
//                         <Grid container spacing={2}>
//                             {/* Training Name with Course Selection Popup */}
//                             <Grid item xs={12}>
//                                 <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
//                                     <TextField
//                                         fullWidth
//                                         label="Training Name"
//                                         name="name"
//                                         value={trainingData.name}
//                                         onChange={handleChange}
//                                         required
//                                         error={!!formErrors.name}
//                                         helperText={formErrors.name || "Click 'Browse All Courses' to select a course"}
//                                         disabled={loader}
//                                         placeholder="Select a course from the course catalog"
//                                         onClick={handleOpenCoursePopup}
//                                         InputProps={{
//                                             readOnly: true,
//                                             sx: { cursor: 'pointer' },
//                                             endAdornment: (
//                                                 <InputAdornment position="end">
//                                                     <Badge badgeContent={allCourses.length} color="primary" sx={{ mr: 1 }}>
//                                                         <Button
//                                                             variant="contained"
//                                                             color="primary"
//                                                             size="medium"
//                                                             onClick={(e) => {
//                                                                 e.stopPropagation();
//                                                                 handleOpenCoursePopup();
//                                                             }}
//                                                             disabled={loader}
//                                                             startIcon={<LibraryBooksIcon />}
//                                                             sx={{ 
//                                                                 textTransform: 'none',
//                                                                 whiteSpace: 'nowrap'
//                                                             }}
//                                                         >
//                                                             Browse All Courses
//                                                         </Button>
//                                                     </Badge>
//                                                 </InputAdornment>
//                                             )
//                                         }}
//                                     />
//                                 </Box>
//                                 {selectedCourse && (
//                                     <Box sx={{ mt: 1, p: 1.5, bgcolor: '#e3f2fd', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1 }}>
//                                         <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
//                                             <CheckCircleIcon sx={{ color: 'success.main', mr: 1 }} />
//                                             <Typography variant="body2" fontWeight="bold">
//                                                 {trainingData.name}
//                                             </Typography>
//                                             {selectedCourse?.level && selectedCourse?.level !== 'Uncategorized' && (
//                                                 <Chip label={`📊 ${selectedCourse.level}`} size="small" variant="outlined" color="info" />
//                                             )}
//                                             {selectedCourse?.duration && selectedCourse?.duration !== 'N/A' && (
//                                                 <Chip label={`⏱ ${selectedCourse.duration}`} size="small" variant="outlined" />
//                                             )}
//                                             {selectedCourse?.language && selectedCourse?.language !== 'N/A' && (
//                                                 <Chip label={`🌐 ${selectedCourse.language}`} size="small" variant="outlined" color="secondary" />
//                                             )}
//                                             {selectedCourse?.category && selectedCourse?.category !== 'Uncategorized' && (
//                                                 <Chip label={`📂 ${selectedCourse.category}`} size="small" variant="outlined" color="primary" />
//                                             )}
//                                         </Box>
//                                         <Button 
//                                             size="small" 
//                                             onClick={() => {
//                                                 setSelectedCourse(null);
//                                                 setTrainingData(prev => ({ ...prev, name: '' }));
//                                             }}
//                                             startIcon={<ClearIcon />}
//                                             color="error"
//                                         >
//                                             Clear
//                                         </Button>
//                                     </Box>
//                                 )}
//                             </Grid>

//                             {/* Course Selection Popup - All Courses Page */}
//                             <Dialog 
//                                 open={isCoursePopupOpen} 
//                                 onClose={handleCloseCoursePopup}
//                                 maxWidth="xl"
//                                 fullWidth
//                                 PaperProps={{
//                                     sx: {
//                                         minHeight: '85vh',
//                                         maxHeight: '95vh'
//                                     }
//                                 }}
//                             >
//                                 <DialogTitle sx={{ bgcolor: 'primary.main', color: 'white' }}>
//                                     <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                                         <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                                             <LibraryBooksIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
//                                             <Typography variant="h5" fontWeight="bold">
//                                                 All Courses
//                                             </Typography>
//                                             <Chip 
//                                                 label={`${filteredAndSortedCourses.length} courses available`} 
//                                                 size="small" 
//                                                 sx={{ ml: 2, bgcolor: 'white', color: 'primary.main' }}
//                                             />
//                                         </Box>
//                                         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                                             {isLoadingCourses && <CircularProgress size={24} color="inherit" />}
//                                             <IconButton onClick={handleCloseCoursePopup} sx={{ color: 'white' }}>
//                                                 <CloseIcon />
//                                             </IconButton>
//                                         </Box>
//                                     </Box>
//                                 </DialogTitle>
//                                 <DialogContent dividers sx={{ bgcolor: '#f5f5f5' }}>
//                                     {/* Search and Filter Bar */}
//                                     <Box sx={{ mb: 3 }}>
//                                         <Grid container spacing={2}>
//                                             <Grid item xs={12} md={4}>
//                                                 <TextField
//                                                     fullWidth
//                                                     placeholder="🔍 Search courses by name, description, category or level..."
//                                                     value={searchTerm}
//                                                     onChange={handleSearchChange}
//                                                     InputProps={{
//                                                         endAdornment: searchTerm && (
//                                                             <InputAdornment position="end">
//                                                                 <IconButton size="small" onClick={() => setSearchTerm('')}>
//                                                                     <ClearIcon />
//                                                                 </IconButton>
//                                                             </InputAdornment>
//                                                         )
//                                                     }}
//                                                     size="small"
//                                                     sx={{ bgcolor: 'white', borderRadius: 1 }}
//                                                 />
//                                             </Grid>
//                                             <Grid item xs={12} md={8}>
//                                                 <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', alignItems: 'center' }}>
//                                                     <FormControl size="small" sx={{ minWidth: 120, bgcolor: 'white', borderRadius: 1 }}>
//                                                         <InputLabel>Category</InputLabel>
//                                                         <Select
//                                                             value={filters.category}
//                                                             label="Category"
//                                                             onChange={(e) => handleFilterChange('category', e.target.value)}
//                                                         >
//                                                             <MenuItem value="">All Categories</MenuItem>
//                                                             {filterOptions.categories.map(cat => (
//                                                                 <MenuItem key={cat} value={cat}>{cat}</MenuItem>
//                                                             ))}
//                                                         </Select>
//                                                     </FormControl>
                                                    
//                                                     <FormControl size="small" sx={{ minWidth: 120, bgcolor: 'white', borderRadius: 1 }}>
//                                                         <InputLabel>Level</InputLabel>
//                                                         <Select
//                                                             value={filters.level}
//                                                             label="Level"
//                                                             onChange={(e) => handleFilterChange('level', e.target.value)}
//                                                         >
//                                                             <MenuItem value="">All Levels</MenuItem>
//                                                             {filterOptions.levels.map(level => (
//                                                                 <MenuItem key={level} value={level}>{level}</MenuItem>
//                                                             ))}
//                                                         </Select>
//                                                     </FormControl>
                                                    
//                                                     <FormControl size="small" sx={{ minWidth: 120, bgcolor: 'white', borderRadius: 1 }}>
//                                                         <InputLabel>Language</InputLabel>
//                                                         <Select
//                                                             value={filters.language}
//                                                             label="Language"
//                                                             onChange={(e) => handleFilterChange('language', e.target.value)}
//                                                         >
//                                                             <MenuItem value="">All Languages</MenuItem>
//                                                             {filterOptions.languages.map(lang => (
//                                                                 <MenuItem key={lang} value={lang}>{lang}</MenuItem>
//                                                             ))}
//                                                         </Select>
//                                                     </FormControl>
                                                    
//                                                     <FormControl size="small" sx={{ minWidth: 120, bgcolor: 'white', borderRadius: 1 }}>
//                                                         <InputLabel>Type</InputLabel>
//                                                         <Select
//                                                             value={filters.type}
//                                                             label="Type"
//                                                             onChange={(e) => handleFilterChange('type', e.target.value)}
//                                                         >
//                                                             <MenuItem value="">All Types</MenuItem>
//                                                             {filterOptions.types.map(type => (
//                                                                 <MenuItem key={type} value={type}>{type}</MenuItem>
//                                                             ))}
//                                                         </Select>
//                                                     </FormControl>
                                                    
//                                                     <Button
//                                                         variant="outlined"
//                                                         size="small"
//                                                         onClick={handleClearFilters}
//                                                         startIcon={<ClearIcon />}
//                                                         sx={{ bgcolor: 'white' }}
//                                                     >
//                                                         Clear
//                                                     </Button>
//                                                 </Box>
//                                             </Grid>
//                                         </Grid>
//                                     </Box>

//                                     {/* Loading State */}
//                                     {isLoadingCourses ? (
//                                         <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 8 }}>
//                                             <CircularProgress />
//                                             <Typography sx={{ ml: 2 }}>Loading courses...</Typography>
//                                         </Box>
//                                     ) : filteredAndSortedCourses.length === 0 ? (
//                                         <Box sx={{ textAlign: 'center', py: 8 }}>
//                                             <LibraryBooksIcon sx={{ fontSize: 80, color: 'text.secondary', mb: 2 }} />
//                                             <Typography variant="h5" color="text.secondary">No courses found</Typography>
//                                             <Typography variant="body1" color="text.secondary">
//                                                 Try adjusting your filters or search terms
//                                             </Typography>
//                                             <Button onClick={handleClearFilters} variant="contained" sx={{ mt: 2 }}>
//                                                 Clear All Filters
//                                             </Button>
//                                         </Box>
//                                     ) : (
//                                         <>
//                                             {/* Show courses grouped by level */}
//                                             {Object.keys(groupedCourses).map((level) => {
//                                                 const levelCourses = groupedCourses[level];
//                                                 const displayedCourses = getLevelCourses(level);
//                                                 const isExpanded = expandedLevels[level] || false;
//                                                 const totalCourses = levelCourses.length;
//                                                 const levelColor = getLevelColor(level);
                                                
//                                                 return (
//                                                     <Box key={level} sx={{ mb: 4 }}>
//                                                         <Box sx={{ 
//                                                             display: 'flex', 
//                                                             alignItems: 'center', 
//                                                             mb: 2,
//                                                             bgcolor: 'white',
//                                                             p: 1.5,
//                                                             borderRadius: 2,
//                                                             boxShadow: 1,
//                                                             flexWrap: 'wrap',
//                                                             gap: 1
//                                                         }}>
//                                                             <LevelIcon sx={{ mr: 1, color: 'primary.main' }} />
//                                                             <Typography variant="h6" fontWeight="bold" color="primary">
//                                                                 {level}
//                                                             </Typography>
//                                                             <Chip 
//                                                                 label={`${totalCourses} course${totalCourses > 1 ? 's' : ''}`} 
//                                                                 size="small" 
//                                                                 sx={{ ml: 2 }}
//                                                             />
//                                                             {hasMoreCourses(level) && (
//                                                                 <Button
//                                                                     size="small"
//                                                                     variant="text"
//                                                                     onClick={() => toggleLevelExpanded(level)}
//                                                                     sx={{ ml: 2 }}
//                                                                     endIcon={<ExpandMoreIcon sx={{ 
//                                                                         transform: isExpanded ? 'rotate(180deg)' : 'none',
//                                                                         transition: 'transform 0.3s'
//                                                                     }} />}
//                                                                 >
//                                                                     {isExpanded ? 'Show Less' : `Show All ${totalCourses}`}
//                                                                 </Button>
//                                                             )}
//                                                         </Box>
//                                                         <Grid container spacing={3}>
//                                                             {displayedCourses.map((course) => renderCourseCard(course))}
//                                                         </Grid>
//                                                         {hasMoreCourses(level) && !isExpanded && (
//                                                             <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
//                                                                 <Button 
//                                                                     variant="outlined" 
//                                                                     size="small"
//                                                                     onClick={() => toggleLevelExpanded(level)}
//                                                                     startIcon={<ExpandMoreIcon />}
//                                                                 >
//                                                                     Show All {totalCourses} Courses
//                                                                 </Button>
//                                                             </Box>
//                                                         )}
//                                                     </Box>
//                                                 );
//                                             })}
//                                         </>
//                                     )}
//                                 </DialogContent>
//                                 <DialogActions sx={{ p: 2, bgcolor: 'white', borderTop: '1px solid #e0e0e0' }}>
//                                     <Button onClick={handleCloseCoursePopup} color="secondary" variant="outlined">
//                                         Cancel
//                                     </Button>
//                                     {selectedCourse && (
//                                         <Button 
//                                             onClick={() => {
//                                                 const courseName = selectedCourse?.title || '';
//                                                 setTrainingData(prev => ({ ...prev, name: courseName }));
//                                                 setIsCoursePopupOpen(false);
//                                             }} 
//                                             color="primary" 
//                                             variant="contained"
//                                             startIcon={<CheckCircleIcon />}
//                                             size="large"
//                                         >
//                                             Select {selectedCourse.title?.length > 30 ? selectedCourse.title.substring(0, 30) + '...' : selectedCourse.title}
//                                         </Button>
//                                     )}
//                                 </DialogActions>
//                             </Dialog>

//                             {/* Training Mode - New Field */}
//                             <Grid item xs={6}>
//                                 <FormControl fullWidth error={!!formErrors.trainingMode}>
//                                     <InputLabel>Training Mode</InputLabel>
//                                     <Select 
//                                         name="trainingMode" 
//                                         value={trainingData.trainingMode} 
//                                         label="Training Mode" 
//                                         onChange={handleChange} 
//                                         required 
//                                         disabled={loader}
//                                     >
//                                         <MenuItem value=""><em>Select Training Mode</em></MenuItem>
//                                         {trainingModeOptions.map((mode) => (
//                                             <MenuItem key={mode.id} value={mode.value}>
//                                                 {mode.label}
//                                             </MenuItem>
//                                         ))}
//                                     </Select>
//                                     {formErrors.trainingMode && <Typography color="error" variant="caption">{formErrors.trainingMode}</Typography>}
//                                 </FormControl>
//                             </Grid>

//                             {/* Batch Plan - New Field */}
//                             <Grid item xs={6}>
//                                 <TextField 
//                                     fullWidth 
//                                     label="Batch Plan" 
//                                     name="batchPlan" 
//                                     type="number" 
//                                     value={trainingData.batchPlan} 
//                                     onChange={handleChange}
//                                     required
//                                     disabled={loader}
//                                     inputProps={{ 
//                                         min: 0, 
//                                         step: 1 
//                                     }}
//                                     helperText="Enter the batch plan number (default: 20)"
//                                     error={!!formErrors.batchPlan}
//                                 />
//                             </Grid>

//                             <Grid item xs={6}>
//                                 <FormControl fullWidth error={!!formErrors.state}>
//                                     <InputLabel>State</InputLabel>
//                                     <Select name="state" value={trainingData.state} label="State" onChange={handleChange} required disabled={loader || showOrg1Options}>
//                                         <MenuItem value=""><em>None</em></MenuItem>
//                                         {stateData.map((state) => (
//                                             <MenuItem key={state.id} value={state.name}>{state.name}</MenuItem>
//                                         ))}
//                                     </Select>
//                                     {formErrors.state && <Typography color="error" variant="caption">{formErrors.state}</Typography>}
//                                 </FormControl>
//                             </Grid>

//                             <Grid item xs={6}>
//                                 <FormControl fullWidth disabled={!trainingData.state || loader || showOrg1Options} error={!!formErrors.depot}>
//                                     <InputLabel>Depot</InputLabel>
//                                     <Select name="depot" value={trainingData.depot} label="Depot" onChange={handleChange} required>
//                                         <MenuItem value=""><em>None</em></MenuItem>
//                                         {depotsForState.map((depot, index) => (
//                                             <MenuItem key={index} value={depot}>{depot}</MenuItem>
//                                         ))}
//                                     </Select>
//                                     {formErrors.depot && <Typography color="error" variant="caption">{formErrors.depot}</Typography>}
//                                 </FormControl>
//                             </Grid>

//                             <Grid item xs={6}>
//                                 <FormControl fullWidth error={!!formErrors.type}>
//                                     <InputLabel>Training Type</InputLabel>
//                                     <Select name="type" value={trainingData.type} label="Training Type" onChange={handleChange} required disabled={loader}>
//                                         <MenuItem value=""><em>Select Type</em></MenuItem>
//                                         {typeData.map((type) => (
//                                             <MenuItem key={type.id} value={type.name}>
//                                                 <Box sx={{ display: 'flex', alignItems: 'center' }}>{type.name}{type.icon}</Box>
//                                             </MenuItem>
//                                         ))}
//                                     </Select>
//                                     {formErrors.type && <Typography color="error" variant="caption">{formErrors.type}</Typography>}
//                                 </FormControl>
//                             </Grid>

//                             <Grid item xs={6}>
//                                 <FormControl fullWidth error={!!formErrors.trainingDays}>
//                                     <InputLabel>Training Days</InputLabel>
//                                     <Select name="trainingDays" value={trainingData.trainingDays} label="Training Days" onChange={handleChange} required disabled={loader}>
//                                         <MenuItem value=""><em>Select Days</em></MenuItem>
//                                         <MenuItem value="0">Manual Date Selection</MenuItem>
//                                         {trainingDayOptions.map((days) => (
//                                             <MenuItem key={days} value={days}>{days} Day{days > 1 ? 's' : ''}</MenuItem>
//                                         ))}
//                                     </Select>
//                                     {formErrors.trainingDays && <Typography color="error" variant="caption">{formErrors.trainingDays}</Typography>}
//                                 </FormControl>
//                             </Grid>

//                             {/* Duration Selection - Always show when training days is selected */}
//                             {trainingData.trainingDays !== "" && (
//                                 <Grid item xs={6}>
//                                     <FormControl fullWidth error={!!formErrors.duration}>
//                                         <InputLabel>Select Duration (Hours per day)</InputLabel>
//                                         <Select value={selectedDuration || ''} label="Select Duration (Hours per day)" onChange={handleDurationChange} required disabled={loader}>
//                                             <MenuItem value=""><em>Select Duration</em></MenuItem>
//                                             {[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24].map((duration) => (
//                                                 <MenuItem key={duration} value={duration}>{duration} Hour{duration > 1 ? 's' : ''}</MenuItem>
//                                             ))}
//                                         </Select>
//                                         {formErrors.duration && <Typography color="error" variant="caption">{formErrors.duration}</Typography>}
//                                     </FormControl>
//                                 </Grid>
//                             )}

//                             {isTechnicalTraining && (
//                                 <Grid item xs={12}>
//                                     <FormControl fullWidth error={!!formErrors.technicalAssessmentType}>
//                                         <InputLabel>Assessment Type</InputLabel>
//                                         <Select value={trainingData.technicalAssessmentType} label="Assessment Type" onChange={handleAssessmentTypeChange} required disabled={loader}>
//                                             <MenuItem value=""><em>Select Assessment Type</em></MenuItem>
//                                             {assessmentTypeData.map((assessment) => (
//                                                 <MenuItem key={assessment.id} value={assessment.name} sx={{ borderLeft: `4px solid ${assessment.color}` }}>
//                                                     <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
//                                                         <Typography sx={{ fontWeight: 'bold', mr: 2 }}>{assessment.icon} {assessment.name}</Typography>
//                                                         <Typography variant="body2" color="text.secondary">{assessment.description}</Typography>
//                                                     </Box>
//                                                 </MenuItem>
//                                             ))}
//                                         </Select>
//                                         {selectedAssessment && (
//                                             <Box sx={{ mt: 2, p: 2, bgcolor: '#f5f5f5', borderRadius: 1, border: `2px solid ${selectedAssessment.color}` }}>
//                                                 <Typography variant="subtitle2" sx={{ display: 'flex', alignItems: 'center' }}>
//                                                     <span style={{ fontSize: '1.2rem', marginRight: '8px' }}>{selectedAssessment.icon}</span>
//                                                     <span style={{ color: selectedAssessment.color, fontWeight: 'bold' }}>{selectedAssessment.fullName}</span>
//                                                 </Typography>
//                                                 <Alert severity="info" sx={{ mt: 1 }}><strong>Requirements:</strong> {selectedAssessment.requirements}</Alert>
//                                             </Box>
//                                         )}
//                                     </FormControl>
//                                 </Grid>
//                             )}

//                             <Grid item xs={12}>
//                                 <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
//                                     <CalendarTodayIcon sx={{ mr: 1, color: 'primary.main' }} />
//                                     <Typography variant="subtitle2">Training Dates</Typography>
//                                 </Box>
//                             </Grid>

//                             <Grid item xs={12}>
//                                 <Box sx={{ mb: 2, p: 2, bgcolor: '#e3f2fd', borderRadius: 1 }}>
//                                     <FormControlLabel control={<Checkbox checked={trainingData.allowPreviousDates} onChange={handleAllowPreviousDatesChange} />} label="Allow Previous Dates" />
//                                     <Typography variant="caption" color="text.secondary" sx={{ ml: 4 }}>Enable this to allow selecting past dates for training</Typography>
//                                 </Box>
//                             </Grid>

//                             <Grid item xs={6}>
//                                 <TextField fullWidth label="Training Start Date" name="trainingStartDate" type="date" value={trainingData.trainingStartDate}
//                                     onChange={handleChange} InputLabelProps={{ shrink: true }} required error={!!formErrors.trainingStartDate}
//                                     helperText={formErrors.trainingStartDate || ""} disabled={loader} />
//                             </Grid>

//                             {isManualDateSelection ? (
//                                 <Grid item xs={6}>
//                                     <TextField fullWidth label="Training End Date" name="manualEndDate" type="date" value={trainingData.manualEndDate}
//                                         onChange={handleChange} InputLabelProps={{ shrink: true }} required error={!!formErrors.manualEndDate}
//                                         helperText={formErrors.manualEndDate || "Select the end date for the training"} disabled={loader || !trainingData.trainingStartDate}
//                                         inputProps={{ min: trainingData.trainingStartDate }} />
//                                 </Grid>
//                             ) : (
//                                 <Grid item xs={6}>
//                                     <TextField fullWidth label="Calculated End Date" value={calculatedEndDate} disabled 
//                                         helperText={calculatedEndDate ? "End date calculated based on training days" : "Select start date, days, and time slot to calculate"} />
//                                 </Grid>
//                             )}

//                             {isManualDateSelection && trainingData.trainingStartDate && trainingData.manualEndDate && (
//                                 <Grid item xs={12}>
//                                     <Box sx={{ p: 2, bgcolor: '#f5f5f5', borderRadius: 1 }}>
//                                         <Typography variant="subtitle2" gutterBottom>Select Days of Week (Optional):</Typography>
//                                         <Typography variant="caption" color="text.secondary" sx={{ mb: 1, display: 'block' }}>
//                                             Leave unchecked to include all days, or select specific days for training
//                                         </Typography>
//                                         <FormGroup row>
//                                             {daysOfWeek.map((day) => (
//                                                 <FormControlLabel key={day.id} control={<Checkbox checked={trainingData.selectedDaysOfWeek.includes(day.id)} onChange={() => handleDaysOfWeekChange(day.id)} />} label={day.short} />
//                                             ))}
//                                         </FormGroup>
//                                     </Box>
//                                 </Grid>
//                             )}

//                             {/* Time Selection Section - Shows when duration is selected */}
//                             {selectedDuration && trainingData.trainingStartDate && (
//                                 <>
//                                     <Grid item xs={12}>
//                                         <Box sx={{ display: 'flex', alignItems: 'center', mt: 2, mb: 1 }}>
//                                             <AccessTimeIcon sx={{ mr: 1, color: 'primary.main' }} />
//                                             <Typography variant="subtitle2">Training Time Selection {trainingData.use24HourFormat ? "(24-Hour Format)" : "(12-Hour Format)"}</Typography>
//                                         </Box>
//                                     </Grid>

//                                     <Grid item xs={12}>
//                                         <Paper sx={{ p: 2, bgcolor: '#f5f5f5' }}>
//                                             <FormControl component="fieldset" fullWidth>
//                                                 <FormLabel component="legend">Choose Time Selection Method</FormLabel>
//                                                 <RadioGroup row value={trainingData.selectedTimeMode} onChange={(e) => handleTimeModeChange(e.target.value)}>
//                                                     <FormControlLabel value="preset" control={<Radio />} label="🎯 All Time Slots" />
//                                                     <FormControlLabel value="range" control={<Radio />} label="📊 Pre-defined Time Ranges" />
//                                                     <FormControlLabel value="custom" control={<Radio />} label="✏️ Custom Time Range" />
//                                                 </RadioGroup>
//                                             </FormControl>
//                                         </Paper>
//                                     </Grid>

//                                     {trainingData.selectedTimeMode === 'preset' && (
//                                         <Grid item xs={12}>
//                                             <Alert severity="info" icon={<ScheduleIcon />} sx={{ mb: 2 }}>
//                                                 Showing all available time slots from 00:00 to 23:00 ({trainingData.use24HourFormat ? '24-hour' : '12-hour'} format) for {selectedDuration} hour{selectedDuration > 1 ? 's' : ''} per day
//                                             </Alert>
//                                         </Grid>
//                                     )}

//                                     {trainingData.selectedTimeMode === 'range' && (
//                                         <Grid item xs={12}>
//                                             <FormControl fullWidth sx={{ mb: 2 }}>
//                                                 <InputLabel>Select Time Range</InputLabel>
//                                                 <Select value={trainingData.selectedTimeRange} label="Select Time Range" onChange={(e) => handleTimeRangeChange(e.target.value)}>
//                                                     {timeRanges.map((range) => (
//                                                         <MenuItem key={range.id} value={range.id}>{range.icon} {range.label}</MenuItem>
//                                                     ))}
//                                                 </Select>
//                                             </FormControl>
                                            
//                                             {trainingData.selectedTimeRange === 'flexible' && (
//                                                 <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
//                                                     <FormControl fullWidth>
//                                                         <InputLabel>Start Hour (00-23)</InputLabel>
//                                                         <Select value={trainingData.customRangeMinHour} label="Start Hour (00-23)" onChange={(e) => handleCustomRangeChange('min', e.target.value)}>
//                                                             {[...Array(24).keys()].map(hour => (
//                                                                 <MenuItem key={hour} value={hour}>{hour.toString().padStart(2, '0')}:00</MenuItem>
//                                                             ))}
//                                                         </Select>
//                                                     </FormControl>
//                                                     <FormControl fullWidth>
//                                                         <InputLabel>End Hour (01-24)</InputLabel>
//                                                         <Select value={trainingData.customRangeMaxHour} label="End Hour (01-24)" onChange={(e) => handleCustomRangeChange('max', e.target.value)}>
//                                                             {[...Array(24).keys()].map(hour => (
//                                                                 <MenuItem key={hour + 1} value={hour + 1}>{(hour + 1).toString().padStart(2, '0')}:00</MenuItem>
//                                                             ))}
//                                                             <MenuItem value={24}>00:00 (next day)</MenuItem>
//                                                         </Select>
//                                                     </FormControl>
//                                                 </Box>
//                                             )}
//                                         </Grid>
//                                     )}

//                                     {trainingData.selectedTimeMode === 'custom' && (
//                                         <Grid item xs={12}>
//                                             <Alert severity="info" icon={<ScheduleIcon />} sx={{ mb: 2 }}>
//                                                 Set your custom start and end time. Duration must match the selected {selectedDuration} hour(s).
//                                             </Alert>
//                                             <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
//                                                 <Card sx={{ flex: 1 }}>
//                                                     <CardContent>
//                                                         <Typography variant="subtitle2" gutterBottom>Start Time</Typography>
//                                                         <Box sx={{ display: 'flex', gap: 1 }}>
//                                                             <FormControl fullWidth>
//                                                                 <Select value={trainingData.customStartHour} onChange={(e) => handleCustomStartChange('customStartHour', e.target.value)}>
//                                                                     {trainingData.use24HourFormat 
//                                                                         ? [...Array(24).keys()].map(hour => <MenuItem key={hour} value={hour}>{hour.toString().padStart(2, '0')}:00</MenuItem>)
//                                                                         : [1,2,3,4,5,6,7,8,9,10,11,12].map(hour => <MenuItem key={hour} value={hour}>{hour}</MenuItem>)
//                                                                     }
//                                                                 </Select>
//                                                             </FormControl>
//                                                             <FormControl fullWidth>
//                                                                 <Select value={trainingData.customStartMinute} onChange={(e) => handleCustomStartChange('customStartMinute', e.target.value)}>
//                                                                     <MenuItem value={0}>00</MenuItem>
//                                                                     <MenuItem value={30}>30</MenuItem>
//                                                                 </Select>
//                                                             </FormControl>
//                                                             {!trainingData.use24HourFormat && (
//                                                                 <FormControl fullWidth>
//                                                                     <Select value={trainingData.customStartAmPm} onChange={(e) => handleCustomStartChange('customStartAmPm', e.target.value)}>
//                                                                         <MenuItem value="AM">AM</MenuItem>
//                                                                         <MenuItem value="PM">PM</MenuItem>
//                                                                     </Select>
//                                                                 </FormControl>
//                                                             )}
//                                                         </Box>
//                                                     </CardContent>
//                                                 </Card>
//                                                 <Card sx={{ flex: 1 }}>
//                                                     <CardContent>
//                                                         <Typography variant="subtitle2" gutterBottom>End Time</Typography>
//                                                         <Box sx={{ display: 'flex', gap: 1 }}>
//                                                             <FormControl fullWidth>
//                                                                 <Select value={trainingData.customEndHour} onChange={(e) => handleCustomStartChange('customEndHour', e.target.value)}>
//                                                                     {trainingData.use24HourFormat 
//                                                                         ? [...Array(24).keys()].map(hour => <MenuItem key={hour} value={hour}>{hour.toString().padStart(2, '0')}:00</MenuItem>)
//                                                                         : [1,2,3,4,5,6,7,8,9,10,11,12].map(hour => <MenuItem key={hour} value={hour}>{hour}</MenuItem>)
//                                                                     }
//                                                                 </Select>
//                                                             </FormControl>
//                                                             <FormControl fullWidth>
//                                                                 <Select value={trainingData.customEndMinute} onChange={(e) => handleCustomStartChange('customEndMinute', e.target.value)}>
//                                                                     <MenuItem value={0}>00</MenuItem>
//                                                                     <MenuItem value={30}>30</MenuItem>
//                                                                 </Select>
//                                                             </FormControl>
//                                                             {!trainingData.use24HourFormat && (
//                                                                 <FormControl fullWidth>
//                                                                     <Select value={trainingData.customEndAmPm} onChange={(e) => handleCustomStartChange('customEndAmPm', e.target.value)}>
//                                                                         <MenuItem value="AM">AM</MenuItem>
//                                                                         <MenuItem value="PM">PM</MenuItem>
//                                                                     </Select>
//                                                                 </FormControl>
//                                                             )}
//                                                         </Box>
//                                                     </CardContent>
//                                                 </Card>
//                                             </Box>
//                                         </Grid>
//                                     )}

//                                     {availableTimeSlots.length > 0 && (
//                                         <Grid item xs={12}>
//                                             <FormControl fullWidth error={!!formErrors.timeSlot}>
//                                                 <InputLabel>Select Time Slot</InputLabel>
//                                                 <Select value={trainingData.selectedTimeSlot?.id || ''} label="Select Time Slot" onChange={(e) => {
//                                                     const slot = availableTimeSlots.find(s => s.id === e.target.value);
//                                                     handleTimeSlotChange(slot);
//                                                 }}>
//                                                     <MenuItem value=""><em>Select Time Slot</em></MenuItem>
//                                                     {availableTimeSlots.map((slot) => (
//                                                         <MenuItem key={slot.id} value={slot.id}>
//                                                             {trainingData.use24HourFormat 
//                                                                 ? `${slot.startTime24 || slot.startTime} - ${slot.endTime24 || slot.endTime}`
//                                                                 : slot.displayLabel
//                                                             }
//                                                         </MenuItem>
//                                                     ))}
//                                                 </Select>
//                                                 {formErrors.timeSlot && <Typography color="error" variant="caption">{formErrors.timeSlot}</Typography>}
                                                
//                                                 <Box sx={{ mt: 2, maxHeight: '150px', overflowY: 'auto' }}>
//                                                     <Typography variant="caption" color="text.secondary">Quick Select:</Typography>
//                                                     <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1 }}>
//                                                         {availableTimeSlots.slice(0, 15).map((slot) => (
//                                                             <Chip 
//                                                                 key={slot.id} 
//                                                                 label={trainingData.use24HourFormat 
//                                                                     ? `${slot.startTime24 || slot.startTime} - ${slot.endTime24 || slot.endTime}`
//                                                                     : slot.shortLabel
//                                                                 }
//                                                                 onClick={() => handleTimeSlotChange(slot)}
//                                                                 color={trainingData.selectedTimeSlot?.id === slot.id ? "primary" : "default"}
//                                                                 variant={trainingData.selectedTimeSlot?.id === slot.id ? "filled" : "outlined"}
//                                                                 size="small" 
//                                                                 disabled={loader} 
//                                                             />
//                                                         ))}
//                                                     </Box>
//                                                 </Box>
//                                             </FormControl>
//                                         </Grid>
//                                     )}
//                                 </>
//                             )}

//                             {trainingData.selectedTimeSlot && (
//                                 <Grid item xs={12}>
//                                     <Alert severity="success" icon={<CheckCircleIcon />}>
//                                         <strong>Selected Time Slot:</strong> {formatTimeForDisplay(trainingData.selectedTimeSlot.startTime)} - {formatTimeForDisplay(trainingData.selectedTimeSlot.endTime)} &nbsp;
//                                         ({trainingData.selectedTimeSlot.duration} hour{trainingData.selectedTimeSlot.duration > 1 ? 's' : ''} per day)
//                                     </Alert>
//                                 </Grid>
//                             )}

//                             {(trainingData.trainingStartDate && trainingData.selectedTimeSlot && (calculatedEndDate || trainingData.manualEndDate)) && (
//                                 <Grid item xs={12}>
//                                     <Alert severity="info">
//                                         <strong>Training Summary:</strong><br />
//                                         • Course: <strong>{trainingData.name || 'Not selected'}</strong><br />
//                                         • Mode: <strong>{trainingData.trainingMode || 'Not selected'}</strong><br />
//                                         • Batch Plan: <strong>{trainingData.batchPlan}</strong><br />
//                                         • Type: <strong>{getConcatenatedTypeMessage()}</strong><br />
//                                         • Duration per day: <strong>{selectedDuration} hour{selectedDuration > 1 ? 's' : ''}</strong><br />
//                                         • {isManualDateSelection ? 
//                                             `Date Range: ${format(parseISO(trainingData.trainingStartDate), 'MMM dd, yyyy')} to ${format(parseISO(trainingData.manualEndDate), 'MMM dd, yyyy')}` : 
//                                             `Start: ${format(parseISO(trainingData.trainingStartDate), 'MMM dd, yyyy')} at ${formatTimeForDisplay(trainingData.selectedTimeSlot.startTime)}`}<br />
//                                         {!isManualDateSelection && calculatedEndDate && `• End: ${format(parseISO(calculatedEndDate), 'MMM dd, yyyy')} at ${formatTimeForDisplay(trainingData.selectedTimeSlot.endTime)}<br />`}
//                                         • Total Training Days: <strong>{actualTrainingDays}</strong><br />
//                                         {isTechnicalTraining && `• Assessment: ${selectedAssessment?.name || 'None'}`}
//                                     </Alert>
//                                 </Grid>
//                             )}

//                             {allTrainingDates.length > 0 && (
//                                 <Grid item xs={12}>
//                                     <Paper sx={{ p: 2, bgcolor: '#f5f5f5', maxHeight: '200px', overflowY: 'auto' }}>
//                                         <Typography variant="subtitle2" gutterBottom>
//                                             <CalendarTodayIcon sx={{ mr: 1, fontSize: '1rem', verticalAlign: 'middle' }} />
//                                             Training Schedule ({allTrainingDates.length} days):
//                                         </Typography>
//                                         <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
//                                             {allTrainingDates.map((date, index) => (
//                                                 <Chip 
//                                                     key={index}
//                                                     label={`${format(date.date, 'MMM dd')} (${date.dayOfWeek.substring(0, 3)})`}
//                                                     size="small"
//                                                     color="primary"
//                                                     variant="outlined"
//                                                 />
//                                             ))}
//                                         </Box>
//                                     </Paper>
//                                 </Grid>
//                             )}

//                             <Grid item xs={12}>
//                                 <Divider sx={{ my: 2 }}>
//                                     <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                                         <PersonIcon sx={{ mr: 1 }} />
//                                         <Typography variant="subtitle1" color="primary">Select Trainer</Typography>
//                                     </Box>
//                                 </Divider>
                                
//                                 <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
//                                     <Typography variant="body2" color="text.secondary">Select any user from the system as trainer</Typography>
//                                     <Button size="small" startIcon={<RefreshIcon />} onClick={refreshUsers} disabled={loadingUsers}>Refresh Users</Button>
//                                 </Box>

//                                 <Autocomplete 
//                                     options={allUsers} 
//                                     getOptionLabel={(option) => `${option.name} (${option.userType || 'No Type'})`}
//                                     value={allUsers.find(t => t.id === trainingData.trainerId) || null} 
//                                     onChange={handleTrainerChange}
//                                     disabled={loader || loadingUsers} 
//                                     loading={loadingUsers}
//                                     renderOption={(props, option) => (
//                                         <ListItem {...props} key={option.id}>
//                                             <ListItemText 
//                                                 primary={
//                                                     <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//                                                         <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                                                             <PersonIcon sx={{ mr: 1, fontSize: '1rem', color: 'primary.main' }} />
//                                                             <Typography variant="body1" fontWeight="bold">{option.name}</Typography>
//                                                         </Box>
//                                                         <Chip label={option.userType || 'No Type'} size="small" variant="outlined" />
//                                                     </Box>
//                                                 } 
//                                                 secondary={
//                                                     <>
//                                                         <EmailIcon sx={{ fontSize: '0.8rem', mr: 0.5 }} /> {option.email}
//                                                         {option.mobile && <><br /><PhoneIcon sx={{ fontSize: '0.8rem', mr: 0.5 }} /> {option.mobile}</>}
//                                                     </>
//                                                 } 
//                                             />
//                                         </ListItem>
//                                     )}
//                                     renderInput={(params) => (
//                                         <TextField 
//                                             {...params} 
//                                             label="Select Trainer" 
//                                             required 
//                                             error={!!formErrors.trainer}
//                                             helperText={formErrors.trainer || (loadingUsers ? "Loading users..." : allUsers.length > 0 ? `${allUsers.length} users available` : "No users found")} 
//                                         />
//                                     )} 
//                                 />
                                
//                                 {selectedTrainerInfo && (
//                                     <Box sx={{ mt: 2, p: 2, bgcolor: '#e8f5e9', borderRadius: 1 }}>
//                                         <Typography variant="subtitle2" color="success.main"><strong>Selected Trainer:</strong> {selectedTrainerInfo.name}</Typography>
//                                         <Grid container spacing={1} sx={{ mt: 0.5 }}>
//                                             <Grid item xs={6}><Typography variant="caption"><strong>Email:</strong> {selectedTrainerInfo.email || 'N/A'}</Typography></Grid>
//                                             <Grid item xs={6}><Typography variant="caption"><strong>Phone:</strong> {selectedTrainerInfo.mobile || 'N/A'}</Typography></Grid>
//                                         </Grid>
//                                     </Box>
//                                 )}
//                             </Grid>
//                         </Grid>
                        
//                         <Stack direction="row" spacing={2} justifyContent="flex-end" sx={{ mt: 3 }}>
//                             <Button 
//                                 type="submit" 
//                                 variant="contained" 
//                                 color="primary" 
//                                 disabled={loader || !trainingData.trainerId || !trainingData.selectedTimeSlot || !selectedDuration || Object.keys(formErrors).length > 0}
//                                 sx={{ bgcolor: selectedAssessment?.color, '&:hover': { bgcolor: selectedAssessment?.color, opacity: 0.9 } }}
//                             >
//                                 {loader ? 'Creating...' : `Create Training`}
//                             </Button>
//                             <Button type="button" variant="outlined" color="secondary" onClick={handleClose} disabled={loader}>
//                                 Cancel
//                             </Button>
//                         </Stack>
//                     </form>
//                 </Box>
//             </Modal>
//         </LocalizationProvider>
//     );
// };

// export default CreateTrainingModal;












import React, { useState, useEffect } from 'react';
import {
    Modal,
    Box,
    Typography,
    Button,
    TextField,
    Grid,
    Stack,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Autocomplete,
    Alert,
    Chip,
    ListItem,
    ListItemText,
    Checkbox,
    FormGroup,
    FormControlLabel,
    Divider,
    Tooltip,
    RadioGroup,
    Radio,
    FormLabel,
    Paper,
    Card,
    CardContent,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    InputAdornment,
    CircularProgress,
    Badge,
    Grow,
    CardMedia,
    CardActions,
    FormHelperText,
} from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { fetchAllUsers } from 'helpers/user_helper';
import { fetchAllCourses } from 'helpers/course_helper';
import { generatePresignedUrlForAccess } from 'helpers/Content_helper';
import { format, parseISO, isBefore, isToday, startOfDay } from 'date-fns';
import DOMPurify from 'dompurify';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import BusinessIcon from '@mui/icons-material/Business';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import RefreshIcon from '@mui/icons-material/Refresh';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import SchoolIcon from '@mui/icons-material/School';
import LocalLibraryIcon from '@mui/icons-material/LocalLibrary';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
import BookIcon from '@mui/icons-material/Book';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import ClearIcon from '@mui/icons-material/Clear';
import CategoryIcon from '@mui/icons-material/Category';
import LanguageIcon from '@mui/icons-material/Language';
import TimerIcon from '@mui/icons-material/Timer';
import LevelIcon from '@mui/icons-material/FormatListNumbered';
import PlayCircleFilledIcon from '@mui/icons-material/PlayCircleFilled';
import CancelIcon from '@mui/icons-material/Cancel';
import PauseCircleFilledIcon from '@mui/icons-material/PauseCircleFilled';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 950,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    maxHeight: '90vh',
    overflowY: 'auto',
};

// ==================== STATUS OPTIONS ====================
const STATUS_OPTIONS = [
    { value: 'Active', label: 'Active', color: '#4caf50', bgColor: '#e8f5e9', icon: <PlayCircleFilledIcon />, description: 'Training is active and ongoing' },
    { value: 'Cancelled', label: 'Cancelled', color: '#f44336', bgColor: '#ffebee', icon: <CancelIcon />, description: 'Training has been cancelled' },
    { value: 'Postponed', label: 'Postponed', color: '#ff9800', bgColor: '#fff3e0', icon: <PauseCircleFilledIcon />, description: 'Training has been postponed' },
    { value: 'Completed', label: 'Completed', color: '#2196f3', bgColor: '#e3f2fd', icon: <CheckCircleIcon />, description: 'Training has been completed' },
    { value: 'Other', label: 'Other (Custom Reason)', color: '#9c27b0', bgColor: '#f3e5f5', icon: <HelpOutlineIcon />, description: 'Specify a custom reason' }
];

const generateAllTimeSlots = () => {
    const slots = [];
    for (let duration = 1; duration <= 24; duration++) {
        for (let hour = 0; hour <= 24 - duration; hour++) {
            const startHour24 = hour;
            const endHour24 = hour + duration;
            const startTime24 = `${startHour24.toString().padStart(2, '0')}:00`;
            const endTime24 = `${endHour24.toString().padStart(2, '0')}:00`;
            const startHour12 = startHour24 % 12 || 12;
            const startAmPm = startHour24 < 12 ? 'AM' : 'PM';
            const endHour12 = endHour24 % 12 || 12;
            const endAmPm = endHour24 < 12 ? 'AM' : 'PM';
            const startDisplay = `${startHour12}:00 ${startAmPm}`;
            const endDisplay = `${endHour12}:00 ${endAmPm}`;
            slots.push({
                id: `${duration}-${startHour24}`,
                duration: duration,
                startHour: startHour24,
                endHour: endHour24,
                startTime: startTime24,
                endTime: endTime24,
                displayLabel: `${duration} hour${duration > 1 ? 's' : ''}: ${startDisplay} - ${endDisplay}`,
                shortLabel: `${startDisplay} - ${endDisplay}`,
                timeRange: `${startDisplay} - ${endDisplay}`,
                startHour12, startAmPm, endHour12, endAmPm,
                startTime24, endTime24
            });
        }
    }
    return slots;
};

const timeRanges = [
    { id: 'midnight_early', label: '🌙 Midnight to Early Morning (00:00 - 06:00)', minHour: 0, maxHour: 6 },
    { id: 'early_morning', label: '🌅 Early Morning (06:00 - 09:00)', minHour: 6, maxHour: 9 },
    { id: 'morning', label: '☀️ Morning (09:00 - 12:00)', minHour: 9, maxHour: 12 },
    { id: 'afternoon', label: '☀️ Afternoon (12:00 - 15:00)', minHour: 12, maxHour: 15 },
    { id: 'late_afternoon', label: '🌤️ Late Afternoon (15:00 - 18:00)', minHour: 15, maxHour: 18 },
    { id: 'evening', label: '🌆 Evening (18:00 - 21:00)', minHour: 18, maxHour: 21 },
    { id: 'night', label: '🌙 Night (21:00 - 00:00)', minHour: 21, maxHour: 24 },
    { id: 'full_day', label: '📅 Full Day (00:00 - 23:00)', minHour: 0, maxHour: 24 },
    { id: 'business_hours', label: '💼 Business Hours (09:00 - 18:00)', minHour: 9, maxHour: 18 },
    { id: 'flexible', label: '🕐 Flexible (Custom Range)', minHour: 0, maxHour: 24, isCustom: true },
];

const formatUsers = (users) => {
    if (!users || !Array.isArray(users)) return [];
    return users.map(user => ({
        id: user.id || user.userId,
        name: user.name || user.username,
        email: user.email,
        mobile: user.mobile || user.phone,
        userType: user.userTypeDto?.name || user.userType || '',
        department: user.department || '',
        role: user.role || 'User',
        isActive: user.isActive !== undefined ? user.isActive : true
    }));
};

const getUserInfo = () => {
    try {
        const userStr = localStorage.getItem('user');
        if (userStr) return JSON.parse(userStr);
    } catch (error) {
        console.error('Error parsing user info:', error);
    }
    return null;
};

const getLevelOrder = (level) => {
    if (!level) return 999;
    const num = parseInt(level.replace('Level ', ''));
    return isNaN(num) ? 999 : num;
};

const sanitizeHTML = (html) => {
    if (!html) return '';
    return DOMPurify.sanitize(html, {
        ALLOWED_TAGS: ['p', 'br', 'strong', 'b', 'em', 'i', 'u', 'ul', 'ol', 'li', 'span', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
        ALLOWED_ATTR: ['class', 'style']
    });
};

const groupCoursesByLevel = (courses) => {
    const groups = {};
    courses.forEach(course => {
        const level = course.level || 'Uncategorized';
        if (!groups[level]) groups[level] = [];
        groups[level].push(course);
    });
    const sortedKeys = Object.keys(groups).sort((a, b) => {
        const aNum = getLevelOrder(a);
        const bNum = getLevelOrder(b);
        if (aNum !== bNum) return aNum - bNum;
        return a.localeCompare(b);
    });
    const sortedGroups = {};
    sortedKeys.forEach(key => {
        sortedGroups[key] = groups[key].sort((a, b) => {
            const titleA = String(a?.title || '').toLowerCase();
            const titleB = String(b?.title || '').toLowerCase();
            return titleA.localeCompare(titleB);
        });
    });
    return sortedGroups;
};

const CreateTrainingModal = ({ isOpen, onClose, onCreateTraining, allBatch, allTrainers, allCourseNames = [], loader, organizationId, userType }) => {
    const userInfo = getUserInfo();
    const orgId = organizationId || userInfo?.orgId || 0;
    const currentUserType = userType || userInfo?.userType || '';
    const isOrg1 = orgId === 1;
    const isAdmin = currentUserType?.toLowerCase() === 'admin';
    const showOrg1Options = isOrg1 || isAdmin;
    
    const [trainingData, setTrainingData] = useState({
        name: '', depot: '', type: '', trainingMode: '', batchPlan: 20,
        status: 'Active', customReason: '',
        technicalAssessmentType: '', state: '', trainingStartDate: '',
        selectedTimeSlot: null, trainingEndDate: '', trainerId: null,
        trainingDays: '', manualEndDate: '', selectedDaysOfWeek: [],
        allowPreviousDates: true, selectedTimeMode: 'preset',
        selectedTimeRange: 'business_hours', customStartHour: 9,
        customStartMinute: 0, customStartAmPm: 'AM', customEndHour: 5,
        customEndMinute: 0, customEndAmPm: 'PM', customRangeMinHour: 0,
        customRangeMaxHour: 24, use24HourFormat: true,
    });

    const [allUsers, setAllUsers] = useState([]);
    const [loadingUsers, setLoadingUsers] = useState(false);
    const [calculatedEndDate, setCalculatedEndDate] = useState('');
    const [actualTrainingDays, setActualTrainingDays] = useState(0);
    const [allTrainingDates, setAllTrainingDates] = useState([]);
    const [formErrors, setFormErrors] = useState({});
    const [selectedDuration, setSelectedDuration] = useState(null);
    const [isManualDateSelection, setIsManualDateSelection] = useState(false);
    const [selectedTrainerInfo, setSelectedTrainerInfo] = useState(null);
    const [availableTimeSlots, setAvailableTimeSlots] = useState([]);
    const [allTimeSlots] = useState(generateAllTimeSlots());
    
    const [isCoursePopupOpen, setIsCoursePopupOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedCourse, setSelectedCourse] = useState(null);
    const [page, setPage] = useState(1);
    const [isLoadingCourses, setIsLoadingCourses] = useState(false);
    
    const [filters, setFilters] = useState({
        category: '', level: '', language: '', type: '',
        sortBy: 'title', sortOrder: 'asc', showScorm: false
    });

    const [allCourses, setAllCourses] = useState([]);
    const [filteredCourses, setFilteredCourses] = useState([]);
    const [expandedLevels, setExpandedLevels] = useState({});

    const trainingModeOptions = [
        { id: 'Internal', label: 'Internal', value: 'Internal' },
        { id: 'External', label: 'External', value: 'External' }
    ];

    useEffect(() => {
        if (isOpen) fetchCourses();
    }, [isOpen]);

    const fetchCourses = async () => {
        try {
            setIsLoadingCourses(true);
            const data = await fetchAllCourses();
            if (data?.success) {
                const coursesWithThumbnails = await updateThumbnails(data?.result || []);
                setAllCourses(coursesWithThumbnails);
                setFilteredCourses(coursesWithThumbnails);
            }
        } catch (error) {
            console.error('Error fetching courses:', error);
        } finally {
            setIsLoadingCourses(false);
        }
    };

    const updateThumbnails = async (courses) => {
        if (!courses || courses.length === 0) return courses;
        try {
            const updatedCourses = await Promise.all(
                courses.map(async (course) => {
                    if (course?.thumbnailName) {
                        const response = await generatePresignedUrlForAccess({ 
                            name: course.thumbnailName, type: "image" 
                        });
                        if (response?.success) {
                            return { ...course, thumbnailUrl: response.presignedUrl, image: response.presignedUrl };
                        }
                    }
                    return { ...course, thumbnailUrl: '/images/default-course.jpg', image: '/images/default-course.jpg' };
                })
            );
            return updatedCourses;
        } catch (error) {
            console.error('Error updating thumbnails:', error);
            return courses.map(course => ({ ...course, thumbnailUrl: '/images/default-course.jpg', image: '/images/default-course.jpg' }));
        }
    };

    const filteredAndSortedCourses = React.useMemo(() => {
        let result = [...allCourses];
        if (searchTerm) {
            const term = searchTerm.toLowerCase();
            result = result.filter(course => {
                const title = String(course?.title || '').toLowerCase();
                const desc = String(course?.description || '').toLowerCase();
                const category = String(course?.category || '').toLowerCase();
                const level = String(course?.level || '').toLowerCase();
                return title.includes(term) || desc.includes(term) || category.includes(term) || level.includes(term);
            });
        }
        if (filters.category) result = result.filter(course => String(course?.category || '').toLowerCase() === filters.category.toLowerCase());
        if (filters.type) result = result.filter(course => String(course?.type || '').toLowerCase() === filters.type.toLowerCase());
        if (filters.level) result = result.filter(course => String(course?.level || '').toLowerCase() === filters.level.toLowerCase());
        if (filters.language) result = result.filter(course => String(course?.language || '').toLowerCase().includes(filters.language.toLowerCase()));
        result.sort((a, b) => {
            const levelA = getLevelOrder(a.level);
            const levelB = getLevelOrder(b.level);
            if (levelA !== levelB) return levelA - levelB;
            return String(a?.title || '').toLowerCase().localeCompare(String(b?.title || '').toLowerCase());
        });
        return result;
    }, [allCourses, searchTerm, filters]);

    const groupedCourses = React.useMemo(() => groupCoursesByLevel(filteredAndSortedCourses), [filteredAndSortedCourses]);

    const filterOptions = React.useMemo(() => {
        const categories = new Set();
        const levels = new Set();
        const languages = new Set();
        const types = new Set();
        allCourses.forEach(course => {
            if (course.category) categories.add(course.category);
            if (course.level) levels.add(course.level);
            if (course.language) course.language.split('/').forEach(lang => languages.add(lang.trim()));
            if (course.type) types.add(course.type);
        });
        return {
            categories: Array.from(categories),
            levels: Array.from(levels).sort((a, b) => getLevelOrder(a) - getLevelOrder(b)),
            languages: Array.from(languages),
            types: Array.from(types)
        };
    }, [allCourses]);

    const toggleLevelExpanded = (level) => {
        setExpandedLevels(prev => ({ ...prev, [level]: !prev[level] }));
    };

    const getLevelCourses = (level) => {
        const courses = groupedCourses[level] || [];
        const isExpanded = expandedLevels[level] || false;
        return isExpanded ? courses : courses.slice(0, 9);
    };

    const hasMoreCourses = (level) => (groupedCourses[level] || []).length > 9;

    const getLevelColor = (level) => {
        if (!level) return '#6c757d';
        const num = getLevelOrder(level);
        if (num === 1) return '#28a745';
        if (num === 2) return '#ffc107';
        if (num === 3) return '#fd7e14';
        if (num === 4) return '#dc3545';
        if (num === 5) return '#6f42c1';
        return '#6c757d';
    };

    const defaultStateData = [
        { id: 1, name: "Ahmedabad" }, { id: 2, name: "Bangalore" }, { id: 3, name: "Delhi" },
        { id: 4, name: "Jammu" }, { id: 5, name: "Jamshedpur" }, { id: 6, name: "Mumbai" },
        { id: 7, name: "Odisha" }, { id: 8, name: "Srinagar" }, { id: 9, name: "Uttarakhand" },
        { id: 10, name: "Online" },
    ];
    const org1StateData = [{ id: 1, name: "Online" }];
    const stateData = showOrg1Options ? org1StateData : defaultStateData;

    const defaultDepotMapping = {
        Ahmedabad: ["BBM", "Naranpura", "Online"],
        Bangalore: ["Jayanagar", "Hennur", "Peenya", "Shanti Nagar", "Deepanjali Nagar", "Jigani", "Kannalli", "K R Puram", "Online", "Vaddarahalli", "Traffic Management Centre (TMC)"],
        Delhi: ["BBM", "Hasanpur", "Mayapuri", "Naraina", "Kalkaji", "Sukhdev Vihar", "Nehru Place", "Mundela Kalan", "Rohini-1", "Rohini-2", "Subhash Place", "Wazirpur", "Nand Nagri", "Indraprastha", "TSS", "Online"],
        Jammu: ["Bhagwati Nagar", "Online"],
        Jamshedpur: ["Mera Mandali", "Online"],
        Mumbai: ["Worli", "Malwani", "Shivaji Nagar", "Backbay", "Online"],
        Odisha: ["Kalinga Nagar", "Online"],
        Srinagar: ["Pantha Chowk", "Online"],
        Uttarakhand: ["Pantnagar", "Online"],
        Online: ["Online"]
    };
    const org1DepotMapping = { Online: ["Online"] };
    const depotMapping = showOrg1Options ? org1DepotMapping : defaultDepotMapping;

    const defaultTypeData = [
        { id: 1, name: "Safety" }, { id: 2, name: "IT" }, { id: 3, name: "Technical" }, { id: 4, name: "Driver" },
    ];
    const org1TypeData = [
        { id: 1, name: "Skilling", icon: <SchoolIcon sx={{ ml: 1, fontSize: '1rem', color: 'primary.main' }} /> },
        { id: 2, name: "Upskilling", icon: <LocalLibraryIcon sx={{ ml: 1, fontSize: '1rem', color: 'success.main' }} /> },
        { id: 3, name: "Paid Trainings", icon: <BusinessIcon sx={{ ml: 1, fontSize: '1rem', color: 'warning.main' }} /> },
        { id: 4, name: "Corporate", icon: <CorporateFareIcon sx={{ ml: 1, fontSize: '1rem', color: 'info.main' }} /> },
        { id: 5, name: "School Project", icon: <SchoolIcon sx={{ ml: 1, fontSize: '1rem', color: 'secondary.main' }} /> },
        { id: 6, name: "University & College", icon: <LocalLibraryIcon sx={{ ml: 1, fontSize: '1rem', color: 'primary.main' }} /> },
        { id: 7, name: "Skill Development", icon: <WorkspacePremiumIcon sx={{ ml: 1, fontSize: '1rem', color: 'success.main' }} /> },
    ];
    const typeData = showOrg1Options ? org1TypeData : defaultTypeData;

    const assessmentTypeData = [
        { id: 'bronze', name: 'Bronze', color: '#CD7F32', description: 'Basic technical skills assessment', icon: '🥉', fullName: 'Bronze Assessment', requirements: 'Post-test ≥80%', addToName: true },
        { id: 'silver', name: 'Silver', color: '#C0C0C0', description: 'Intermediate technical skills assessment', icon: '🥈', fullName: 'Silver Assessment', requirements: 'Post-test ≥80%', addToName: true },
        { id: 'gold', name: 'Gold', color: '#FFD700', description: 'Advanced technical skills assessment', icon: '🥇', fullName: 'Gold Assessment', requirements: 'Post-test ≥80%', addToName: true },
        { id: 'other', name: 'Other', color: '#9E9E9E', description: 'Other assessment type', icon: '📋', fullName: 'Other Assessment', requirements: 'Custom assessment', addToName: false }
    ];

    const daysOfWeek = [
        { id: 0, name: 'Sunday', short: 'Sun' }, { id: 1, name: 'Monday', short: 'Mon' },
        { id: 2, name: 'Tuesday', short: 'Tue' }, { id: 3, name: 'Wednesday', short: 'Wed' },
        { id: 4, name: 'Thursday', short: 'Thu' }, { id: 5, name: 'Friday', short: 'Fri' },
        { id: 6, name: 'Saturday', short: 'Sat' },
    ];

    const depotsForState = trainingData.state ? depotMapping[trainingData.state] || ["Online"] : [];
    const trainingDayOptions = [1, 2, 3, 6];
    const isTechnicalTraining = !showOrg1Options && trainingData.type === 'Technical';
    const selectedAssessment = assessmentTypeData.find(a => a.name === trainingData.technicalAssessmentType);
    const shouldAddAssessmentToName = selectedAssessment?.addToName !== false;
    const selectedStatus = STATUS_OPTIONS.find(s => s.value === trainingData.status);

    const formatTimeForDisplay = (time24) => {
        if (!time24) return '';
        if (trainingData.use24HourFormat) return time24;
        const [hours, minutes] = time24.split(':');
        const hour = parseInt(hours);
        const ampm = hour >= 12 ? 'PM' : 'AM';
        const hour12 = hour % 12 || 12;
        return `${hour12}:${minutes} ${ampm}`;
    };

    const convertTo24Hour = (hour, minute, ampm) => {
        let hour24 = hour;
        if (ampm === 'PM' && hour !== 12) hour24 = hour + 12;
        else if (ampm === 'AM' && hour === 12) hour24 = 0;
        return { hour: hour24, minute };
    };

    useEffect(() => {
        if (!selectedDuration) {
            setAvailableTimeSlots([]);
            return;
        }
        let filteredSlots = allTimeSlots.filter(slot => slot.duration === selectedDuration);
        if (trainingData.selectedTimeMode === 'preset') {
            setAvailableTimeSlots(filteredSlots);
        } else if (trainingData.selectedTimeMode === 'range') {
            const range = timeRanges.find(r => r.id === trainingData.selectedTimeRange);
            if (range && !range.isCustom) {
                filteredSlots = filteredSlots.filter(slot => slot.startHour >= range.minHour && slot.endHour <= range.maxHour);
                setAvailableTimeSlots(filteredSlots);
            } else if (range && range.isCustom) {
                filteredSlots = filteredSlots.filter(slot => slot.startHour >= trainingData.customRangeMinHour && slot.endHour <= trainingData.customRangeMaxHour);
                setAvailableTimeSlots(filteredSlots);
            }
        } else if (trainingData.selectedTimeMode === 'custom') {
            const start24 = convertTo24Hour(trainingData.customStartHour, trainingData.customStartMinute, trainingData.customStartAmPm);
            const end24 = convertTo24Hour(trainingData.customEndHour, trainingData.customEndMinute, trainingData.customEndAmPm);
            filteredSlots = filteredSlots.filter(slot => slot.startHour >= start24.hour && slot.endHour <= end24.hour);
            setAvailableTimeSlots(filteredSlots);
        }
    }, [selectedDuration, trainingData.selectedTimeMode, trainingData.selectedTimeRange, trainingData.customStartHour, trainingData.customStartMinute, trainingData.customStartAmPm, trainingData.customEndHour, trainingData.customEndMinute, trainingData.customEndAmPm, trainingData.customRangeMinHour, trainingData.customRangeMaxHour, allTimeSlots]);

    useEffect(() => {
        const loadAllUsers = async () => {
            if (!isOpen) return;
            setLoadingUsers(true);
            try {
                const response = await fetchAllUsers();
                const usersArray = response?.result || response || [];
                setAllUsers(formatUsers(usersArray));
            } catch (error) {
                console.error('Error loading users:', error);
            } finally {
                setLoadingUsers(false);
            }
        };
        loadAllUsers();
    }, [isOpen]);

    useEffect(() => {
        if (showOrg1Options && isOpen) {
            setTrainingData(prev => ({ ...prev, state: "Online", depot: "Online" }));
        }
    }, [showOrg1Options, isOpen]);

    const calculateFixedDates = (startDate, days, timeSlot, selectedDays = []) => {
        if (!startDate || !days || !timeSlot) return { endDate: '', actualTrainingDays: 0, allDates: [] };
        try {
            let start = parseISO(startDate);
            if (isNaN(start.getTime())) return { endDate: '', actualTrainingDays: 0, allDates: [] };
            const allDates = [];
            let trainingDaysCount = 0;
            let currentDate = new Date(start);
            let maxDate = new Date(start);
            if (selectedDays.length > 0) {
                let dayIndex = 0;
                while (trainingDaysCount < days) {
                    const currentDayOfWeek = currentDate.getDay();
                    if (selectedDays.includes(currentDayOfWeek)) {
                        const trainingDate = new Date(currentDate);
                        trainingDate.setHours(timeSlot.startHour, 0);
                        allDates.push({ date: new Date(trainingDate), dayOfWeek: format(trainingDate, 'EEEE'), startTime: timeSlot.startTime, endTime: timeSlot.endTime, duration: timeSlot.duration, isTrainingDay: true });
                        trainingDaysCount++;
                        if (trainingDate > maxDate) maxDate = new Date(trainingDate);
                    }
                    currentDate.setDate(currentDate.getDate() + 1);
                    if (dayIndex > 365) break;
                    dayIndex++;
                }
                maxDate.setHours(timeSlot.endHour, 0);
                const year = maxDate.getFullYear();
                const month = String(maxDate.getMonth() + 1).padStart(2, '0');
                const day = String(maxDate.getDate()).padStart(2, '0');
                return { endDate: `${year}-${month}-${day}`, actualTrainingDays: trainingDaysCount, allDates };
            }
            for (let i = 0; i < days; i++) {
                const trainingDate = new Date(start);
                trainingDate.setDate(start.getDate() + i);
                trainingDate.setHours(timeSlot.startHour, 0);
                allDates.push({ date: new Date(trainingDate), dayOfWeek: format(trainingDate, 'EEEE'), startTime: timeSlot.startTime, endTime: timeSlot.endTime, duration: timeSlot.duration, isTrainingDay: true });
            }
            const endDate = new Date(start);
            endDate.setDate(start.getDate() + days - 1);
            endDate.setHours(timeSlot.endHour, 0);
            const year = endDate.getFullYear();
            const month = String(endDate.getMonth() + 1).padStart(2, '0');
            const day = String(endDate.getDate()).padStart(2, '0');
            return { endDate: `${year}-${month}-${day}`, actualTrainingDays: days, allDates };
        } catch (e) {
            console.error("Error calculating fixed dates:", e);
            return { endDate: '', actualTrainingDays: 0, allDates: [] };
        }
    };

    const calculateManualDates = (startDate, endDate, timeSlot, selectedDays = []) => {
        if (!startDate || !endDate || !timeSlot) return { actualTrainingDays: 0, allDates: [] };
        try {
            const start = parseISO(startDate);
            const end = parseISO(endDate);
            if (isNaN(start.getTime()) || isNaN(end.getTime()) || start > end) return { actualTrainingDays: 0, allDates: [] };
            let current = new Date(start);
            const allDates = [];
            let trainingDaysCount = 0;
            while (current <= end) {
                const currentDay = new Date(current);
                const currentDayOfWeek = currentDay.getDay();
                if (selectedDays.length === 0 || selectedDays.includes(currentDayOfWeek)) {
                    currentDay.setHours(timeSlot.startHour, 0);
                    trainingDaysCount++;
                    allDates.push({ date: new Date(currentDay), dayOfWeek: format(currentDay, 'EEEE'), isTrainingDay: true, startTime: timeSlot.startTime, endTime: timeSlot.endTime, duration: timeSlot.duration });
                }
                current.setDate(current.getDate() + 1);
            }
            return { actualTrainingDays: trainingDaysCount, allDates };
        } catch (e) {
            console.error("Error calculating manual dates:", e);
            return { actualTrainingDays: 0, allDates: [] };
        }
    };

    useEffect(() => {
        if (isManualDateSelection) {
            if (trainingData.trainingStartDate && trainingData.manualEndDate && trainingData.selectedTimeSlot) {
                const { actualTrainingDays, allDates } = calculateManualDates(trainingData.trainingStartDate, trainingData.manualEndDate, trainingData.selectedTimeSlot, trainingData.selectedDaysOfWeek);
                setActualTrainingDays(actualTrainingDays);
                setAllTrainingDates(allDates);
                setCalculatedEndDate(trainingData.manualEndDate);
            } else {
                setActualTrainingDays(0);
                setAllTrainingDates([]);
                setCalculatedEndDate('');
            }
        } else {
            if (trainingData.trainingStartDate && trainingData.trainingDays && trainingData.selectedTimeSlot && trainingData.trainingDays !== "0") {
                const { endDate, actualTrainingDays, allDates } = calculateFixedDates(trainingData.trainingStartDate, parseInt(trainingData.trainingDays), trainingData.selectedTimeSlot, trainingData.selectedDaysOfWeek);
                setCalculatedEndDate(endDate);
                setActualTrainingDays(actualTrainingDays);
                setAllTrainingDates(allDates);
            } else {
                setCalculatedEndDate('');
                setActualTrainingDays(0);
                setAllTrainingDates([]);
            }
        }
    }, [trainingData.trainingStartDate, trainingData.trainingDays, trainingData.selectedTimeSlot, trainingData.manualEndDate, trainingData.selectedDaysOfWeek, isManualDateSelection]);

    const validateForm = () => {
        const errors = {};
        if (!trainingData.name) errors.name = 'Training name is required';
        if (!trainingData.state) errors.state = 'State is required';
        if (!trainingData.depot) errors.depot = 'Depot is required';
        if (!trainingData.type) errors.type = 'Training type is required';
        if (!trainingData.trainingMode) errors.trainingMode = 'Training mode is required';
        if (!trainingData.status) errors.status = 'Status is required';
        if (trainingData.status === 'Other' && !trainingData.customReason?.trim()) errors.customReason = 'Please specify a custom reason';
        if (trainingData.trainingDays === "") errors.trainingDays = 'Training days is required';
        if (!trainingData.trainingStartDate) errors.trainingStartDate = 'Start date is required';
        if (!selectedDuration) errors.duration = 'Duration is required';
        if (!trainingData.selectedTimeSlot) errors.timeSlot = 'Training time slot is required';
        if (!trainingData.trainerId) errors.trainer = 'Trainer is required';
        if (isTechnicalTraining && !trainingData.technicalAssessmentType) errors.technicalAssessmentType = 'Assessment type is required';
        if (isManualDateSelection && !trainingData.manualEndDate) errors.manualEndDate = 'End date is required';
        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'type') {
            setTrainingData(prev => ({ ...prev, [name]: value, technicalAssessmentType: value === 'Technical' ? prev.technicalAssessmentType : '' }));
        } else if (name === 'trainingDays') {
            const isManual = value === "0";
            setIsManualDateSelection(isManual);
            setTrainingData(prev => ({ ...prev, [name]: value, selectedDaysOfWeek: [], manualEndDate: '' }));
            if (isManual) setSelectedDuration(null);
        } else if (name === 'batchPlan') {
            const numValue = parseInt(value) || 0;
            setTrainingData(prev => ({ ...prev, [name]: numValue }));
        } else if (name === 'status') {
            setTrainingData(prev => ({ ...prev, [name]: value, ...(value !== 'Other' ? { customReason: '' } : {}) }));
        } else {
            setTrainingData(prev => ({ ...prev, [name]: value }));
        }
        if (formErrors[name]) setFormErrors(prev => ({ ...prev, [name]: '' }));
    };

    const handleTimeSlotChange = (slot) => {
        setTrainingData(prev => ({ ...prev, selectedTimeSlot: slot }));
        if (formErrors.timeSlot) setFormErrors(prev => ({ ...prev, timeSlot: '' }));
    };

    const handleDurationChange = (event) => {
        setSelectedDuration(event.target.value);
        setTrainingData(prev => ({ ...prev, selectedTimeSlot: null }));
        if (formErrors.duration) setFormErrors(prev => ({ ...prev, duration: '' }));
    };

    const handleTrainerChange = (event, newValue) => {
        setTrainingData(prev => ({ ...prev, trainerId: newValue ? newValue.id : null }));
        setSelectedTrainerInfo(newValue);
        if (formErrors.trainer) setFormErrors(prev => ({ ...prev, trainer: '' }));
    };

    const handleAssessmentTypeChange = (e) => {
        setTrainingData(prev => ({ ...prev, technicalAssessmentType: e.target.value }));
        if (formErrors.technicalAssessmentType) setFormErrors(prev => ({ ...prev, technicalAssessmentType: '' }));
    };

    const handleDaysOfWeekChange = (dayId) => {
        setTrainingData(prev => {
            const currentDays = [...prev.selectedDaysOfWeek];
            const index = currentDays.indexOf(dayId);
            if (index > -1) currentDays.splice(index, 1);
            else currentDays.push(dayId);
            return { ...prev, selectedDaysOfWeek: currentDays };
        });
    };

    const handleAllowPreviousDatesChange = (e) => {
        setTrainingData(prev => ({ ...prev, allowPreviousDates: e.target.checked }));
    };

    const handleTimeModeChange = (mode) => {
        setTrainingData(prev => ({ ...prev, selectedTimeMode: mode, selectedTimeSlot: null }));
    };

    const handleTimeRangeChange = (rangeId) => {
        setTrainingData(prev => ({ ...prev, selectedTimeRange: rangeId, selectedTimeSlot: null }));
    };

    const handleCustomRangeChange = (type, value) => {
        if (type === 'min') setTrainingData(prev => ({ ...prev, customRangeMinHour: value, selectedTimeSlot: null }));
        else setTrainingData(prev => ({ ...prev, customRangeMaxHour: value, selectedTimeSlot: null }));
    };

    const handleCustomStartChange = (field, value) => {
        setTrainingData(prev => ({ ...prev, [field]: value, selectedTimeSlot: null }));
    };

    const handleFormatToggle = () => {
        setTrainingData(prev => ({ ...prev, use24HourFormat: !prev.use24HourFormat }));
    };

    const handleFilterChange = (key, value) => {
        setFilters(prev => ({ ...prev, [key]: value }));
        setPage(1);
        setExpandedLevels({});
    };

    const handleClearFilters = () => {
        setFilters({ category: '', level: '', language: '', type: '', sortBy: 'title', sortOrder: 'asc', showScorm: false });
        setSearchTerm('');
        setPage(1);
        setExpandedLevels({});
    };

    const handleOpenCoursePopup = () => {
        setSearchTerm('');
        setPage(1);
        setSelectedCourse(null);
        handleClearFilters();
        setIsCoursePopupOpen(true);
    };

    const handleCloseCoursePopup = () => {
        setIsCoursePopupOpen(false);
        setSearchTerm('');
        setPage(1);
        setExpandedLevels({});
    };

    const handleSelectCourse = (course) => {
        const courseName = course?.title || '';
        setSelectedCourse(course);
        setTrainingData(prev => ({ ...prev, name: courseName }));
        setIsCoursePopupOpen(false);
        setSearchTerm('');
        setPage(1);
        setExpandedLevels({});
        if (formErrors.name) setFormErrors(prev => ({ ...prev, name: '' }));
    };

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
        setPage(1);
        setExpandedLevels({});
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!validateForm()) return;
        
        const isManual = isManualDateSelection;
        const trainingDaysCount = isManual ? actualTrainingDays : parseInt(trainingData.trainingDays);
        const finalEndDate = isManual ? trainingData.manualEndDate : calculatedEndDate;
        const timeSlot = trainingData.selectedTimeSlot;
        
        if (!finalEndDate || !timeSlot) return;
        
        const startDate = parseISO(trainingData.trainingStartDate);
        const today = startOfDay(new Date());
        const isPastDate = isBefore(startDate, today) && !isToday(startDate);
        
        const timeDisplayShort = trainingData.use24HourFormat 
            ? `${timeSlot.startTime24 || timeSlot.startTime} - ${timeSlot.endTime24 || timeSlot.endTime}`
            : timeSlot.shortLabel;
        
        const concatenatedType = `${trainingData.type} - ${trainingDaysCount} Day${trainingDaysCount > 1 ? 's' : ''} - ${timeDisplayShort}`;
        
        const assessmentInfo = selectedAssessment ? {
            assessmentId: selectedAssessment.id,
            assessmentName: selectedAssessment.name,
            assessmentFullName: selectedAssessment.fullName,
            assessmentColor: selectedAssessment.color,
            assessmentIcon: selectedAssessment.icon,
            addToName: selectedAssessment.addToName
        } : null;
        
        let batchName = trainingData.name;
        if (isTechnicalTraining && selectedAssessment && shouldAddAssessmentToName) {
            batchName = `${selectedAssessment.name} ${trainingData.name}`;
        }
        
        const finalStatus = trainingData.status === 'Other'
            ? `Other: ${trainingData.customReason.trim()}`
            : trainingData.status;
        
        const dataToSend = {
            name: batchName,
            originalName: trainingData.name,
            depot: trainingData.depot,
            type: concatenatedType,
            originalType: trainingData.type,
            trainingMode: trainingData.trainingMode,
            batchPlan: trainingData.batchPlan,
            status: finalStatus,
            customReason: trainingData.customReason,
            technicalAssessmentType: trainingData.technicalAssessmentType,
            assessmentType: trainingData.technicalAssessmentType?.toLowerCase() || '',
            assessmentInfo: assessmentInfo,
            isBronzeAssessment: trainingData.technicalAssessmentType === 'Bronze',
            isSilverAssessment: trainingData.technicalAssessmentType === 'Silver',
            isGoldAssessment: trainingData.technicalAssessmentType === 'Gold',
            isOtherAssessment: trainingData.technicalAssessmentType === 'Other',
            state: trainingData.state,
            trainingStartDate: trainingData.trainingStartDate,
            trainingEndDate: finalEndDate,
            trainerId: trainingData.trainerId,
            trainerName: selectedTrainerInfo?.name || '',
            trainerEmail: selectedTrainerInfo?.email || '',
            trainerPhone: selectedTrainerInfo?.mobile || '',
            trainingDays: trainingDaysCount,
            startTime: timeSlot.startTime,
            endTime: timeSlot.endTime,
            duration: timeSlot.duration,
            timeSlotLabel: timeSlot.displayLabel,
            timeSlotShortLabel: timeDisplayShort,
            actualTrainingDays: actualTrainingDays,
            isManualDateSelection: isManual,
            isTechnicalTraining: isTechnicalTraining,
            selectedDaysOfWeek: trainingData.selectedDaysOfWeek,
            allowPreviousDates: trainingData.allowPreviousDates,
            isPastDate: isPastDate,
            batchSchedule: allTrainingDates.map(d => ({
                date: format(d.date, 'yyyy-MM-dd'),
                dayOfWeek: d.dayOfWeek,
                startTime: d.startTime,
                endTime: d.endTime,
                duration: d.duration
            })),
            organizationId: orgId,
            userType: currentUserType,
            isOrg1: isOrg1,
            isAdmin: isAdmin,
            use24HourFormat: trainingData.use24HourFormat,
            durationHours: selectedDuration,
            courseId: selectedCourse?.id || null,
            courseTitle: selectedCourse?.title || trainingData.name
        };
        
        onCreateTraining(dataToSend);
    };

    const resetForm = () => {
        setTrainingData({
            name: '', depot: '', type: '', trainingMode: '', batchPlan: 20,
            status: 'Active', customReason: '',
            technicalAssessmentType: '', state: '', trainingStartDate: '',
            selectedTimeSlot: null, trainingEndDate: '', trainerId: null, trainingDays: '', manualEndDate: '',
            selectedDaysOfWeek: [], allowPreviousDates: true, selectedTimeMode: 'preset', selectedTimeRange: 'business_hours',
            customStartHour: 9, customStartMinute: 0, customStartAmPm: 'AM', customEndHour: 5, customEndMinute: 0, customEndAmPm: 'PM',
            customRangeMinHour: 0, customRangeMaxHour: 24, use24HourFormat: true,
        });
        setSelectedDuration(null);
        setIsManualDateSelection(false);
        setSelectedTrainerInfo(null);
        setCalculatedEndDate('');
        setActualTrainingDays(0);
        setAllTrainingDates([]);
        setFormErrors({});
        setAvailableTimeSlots([]);
        setSelectedCourse(null);
        setSearchTerm('');
        setPage(1);
        setExpandedLevels({});
        handleClearFilters();
    };

    const handleClose = () => {
        resetForm();
        onClose();
    };

    const today = new Date().toISOString().split('T')[0];

    const refreshUsers = async () => {
        setLoadingUsers(true);
        try {
            const response = await fetchAllUsers();
            const usersArray = response?.result || response || [];
            setAllUsers(formatUsers(usersArray));
        } catch (error) {
            console.error('Error refreshing users:', error);
        } finally {
            setLoadingUsers(false);
        }
    };

    useEffect(() => {
        if (isOpen && !trainingData.trainingStartDate) {
            setTrainingData(prev => ({ ...prev, trainingStartDate: today }));
        }
    }, [isOpen]);

    const getCourseDetails = (course) => {
        if (!course) return null;
        return {
            title: course.title || 'Untitled Course',
            level: course.level || 'Uncategorized',
            category: course.category || 'Uncategorized',
            duration: course.duration || 'N/A',
            language: course.language || 'N/A',
            type: course.type || 'N/A',
            description: course.description || '',
            thumbnailUrl: course.thumbnailUrl || course.image || '/images/default-course.jpg',
            id: course.id || null
        };
    };

    const renderCourseCard = (course) => {
        const isSelected = selectedCourse?.id === course.id;
        const courseDetails = getCourseDetails(course);
        const levelColor = getLevelColor(courseDetails.level);
        
        return (
            <Grow in={true} key={course.id}>
                <Grid item xs={12} sm={6} md={4}>
                    <Card 
                        sx={{ 
                            height: '100%', display: 'flex', flexDirection: 'column', position: 'relative',
                            border: isSelected ? '3px solid #1976d2' : '1px solid #e0e0e0',
                            transition: 'all 0.3s ease',
                            '&:hover': { transform: 'translateY(-8px)', boxShadow: 8 },
                            cursor: 'pointer'
                        }}
                        onClick={() => handleSelectCourse(course)}
                    >
                        {isSelected && (
                            <Box sx={{ position: 'absolute', top: 10, right: 10, zIndex: 1 }}>
                                <Chip label="Selected" color="primary" size="small" icon={<CheckCircleIcon />} />
                            </Box>
                        )}
                        {courseDetails.level && courseDetails.level !== 'Uncategorized' && (
                            <Box sx={{ position: 'absolute', top: 10, left: 10, zIndex: 1 }}>
                                <Chip label={courseDetails.level} size="small" sx={{ bgcolor: levelColor, color: 'white', fontWeight: 'bold' }} />
                            </Box>
                        )}
                        <CardMedia
                            component="img" height="180" image={courseDetails.thumbnailUrl} alt={courseDetails.title}
                            sx={{ objectFit: 'cover', backgroundColor: '#f5f5f5' }}
                            onError={(e) => { e.target.src = '/images/default-course.jpg'; }}
                        />
                        <CardContent sx={{ flexGrow: 1, pt: 1 }}>
                            <Typography variant="subtitle1" fontWeight="bold" sx={{ 
                                display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical',
                                overflow: 'hidden', fontSize: '0.95rem', lineHeight: 1.3, mb: 1
                            }}>
                                {courseDetails.title}
                            </Typography>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 1 }}>
                                <CategoryIcon sx={{ fontSize: '0.8rem', color: 'text.secondary' }} />
                                <Typography variant="caption" color="text.secondary">{courseDetails.category}</Typography>
                            </Box>
                            {courseDetails.duration && courseDetails.duration !== 'N/A' && (
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <TimerIcon sx={{ fontSize: '1rem', color: 'text.secondary' }} />
                                    <Typography variant="body2" color="text.secondary">{courseDetails.duration}</Typography>
                                </Box>
                            )}
                        </CardContent>
                        <CardActions sx={{ p: 2, pt: 0 }}>
                            <Button 
                                fullWidth variant={isSelected ? "contained" : "outlined"} color="primary" size="small"
                                onClick={(e) => { e.stopPropagation(); handleSelectCourse(course); }}
                                startIcon={isSelected ? <CheckCircleIcon /> : <BookIcon />}
                            >
                                {isSelected ? 'Selected' : 'Select Course'}
                            </Button>
                        </CardActions>
                    </Card>
                </Grid>
            </Grow>
        );
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Modal open={isOpen} onClose={handleClose}>
                <Box sx={style}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                        <Typography variant="h6" component="h2">
                            Create New Training
                            {showOrg1Options && <Chip label="Online Mode" size="small" color="primary" sx={{ ml: 2 }} />}
                        </Typography>
                        <Tooltip title={trainingData.use24HourFormat ? "Switch to 12-hour format" : "Switch to 24-hour format"}>
                            <Button size="small" variant="outlined" onClick={handleFormatToggle} sx={{ textTransform: 'none' }}>
                                {trainingData.use24HourFormat ? "24h Format" : "12h Format"}
                            </Button>
                        </Tooltip>
                    </Box>
                    
                    <form onSubmit={handleSubmit}>
                        <Grid container spacing={2}>
                            {/* Training Name */}
                            <Grid item xs={12}>
                                <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                                    <TextField
                                        fullWidth label="Training Name" name="name" value={trainingData.name}
                                        onChange={handleChange} required error={!!formErrors.name}
                                        helperText={formErrors.name || "Click 'Browse All Courses' to select a course"}
                                        disabled={loader} onClick={handleOpenCoursePopup}
                                        InputProps={{
                                            readOnly: true,
                                            sx: { cursor: 'pointer' },
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <Badge badgeContent={allCourses.length} color="primary" sx={{ mr: 1 }}>
                                                        <Button
                                                            variant="contained" color="primary" size="medium"
                                                            onClick={(e) => { e.stopPropagation(); handleOpenCoursePopup(); }}
                                                            disabled={loader} startIcon={<LibraryBooksIcon />}
                                                            sx={{ textTransform: 'none', whiteSpace: 'nowrap' }}
                                                        >
                                                            Browse All Courses
                                                        </Button>
                                                    </Badge>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </Box>
                                {selectedCourse && (
                                    <Box sx={{ mt: 1, p: 1.5, bgcolor: '#e3f2fd', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1 }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
                                            <CheckCircleIcon sx={{ color: 'success.main', mr: 1 }} />
                                            <Typography variant="body2" fontWeight="bold">{trainingData.name}</Typography>
                                        </Box>
                                        <Button size="small" onClick={() => { setSelectedCourse(null); setTrainingData(prev => ({ ...prev, name: '' })); }} startIcon={<ClearIcon />} color="error">
                                            Clear
                                        </Button>
                                    </Box>
                                )}
                            </Grid>

                            {/* Course Popup */}
                            <Dialog open={isCoursePopupOpen} onClose={handleCloseCoursePopup} maxWidth="xl" fullWidth
                                PaperProps={{ sx: { minHeight: '85vh', maxHeight: '95vh' } }}>
                                <DialogTitle sx={{ bgcolor: 'primary.main', color: 'white' }}>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <LibraryBooksIcon sx={{ mr: 1 }} />
                                            <Typography variant="h5" fontWeight="bold">All Courses</Typography>
                                            <Chip label={`${filteredAndSortedCourses.length} courses available`} size="small" sx={{ ml: 2, bgcolor: 'white', color: 'primary.main' }} />
                                        </Box>
                                        <IconButton onClick={handleCloseCoursePopup} sx={{ color: 'white' }}>
                                            <CloseIcon />
                                        </IconButton>
                                    </Box>
                                </DialogTitle>
                                <DialogContent dividers sx={{ bgcolor: '#f5f5f5' }}>
                                    <Box sx={{ mb: 3 }}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} md={4}>
                                                <TextField fullWidth placeholder="🔍 Search courses..." value={searchTerm} onChange={handleSearchChange} size="small" sx={{ bgcolor: 'white', borderRadius: 1 }} />
                                            </Grid>
                                            <Grid item xs={12} md={8}>
                                                <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                                                    <FormControl size="small" sx={{ minWidth: 120, bgcolor: 'white', borderRadius: 1 }}>
                                                        <InputLabel>Category</InputLabel>
                                                        <Select value={filters.category} label="Category" onChange={(e) => handleFilterChange('category', e.target.value)}>
                                                            <MenuItem value="">All</MenuItem>
                                                            {filterOptions.categories.map(cat => <MenuItem key={cat} value={cat}>{cat}</MenuItem>)}
                                                        </Select>
                                                    </FormControl>
                                                    <FormControl size="small" sx={{ minWidth: 120, bgcolor: 'white', borderRadius: 1 }}>
                                                        <InputLabel>Level</InputLabel>
                                                        <Select value={filters.level} label="Level" onChange={(e) => handleFilterChange('level', e.target.value)}>
                                                            <MenuItem value="">All</MenuItem>
                                                            {filterOptions.levels.map(level => <MenuItem key={level} value={level}>{level}</MenuItem>)}
                                                        </Select>
                                                    </FormControl>
                                                    <Button variant="outlined" size="small" onClick={handleClearFilters} sx={{ bgcolor: 'white' }}>Clear</Button>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                    {isLoadingCourses ? (
                                        <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}><CircularProgress /></Box>
                                    ) : filteredAndSortedCourses.length === 0 ? (
                                        <Box sx={{ textAlign: 'center', py: 8 }}>
                                            <Typography variant="h5" color="text.secondary">No courses found</Typography>
                                        </Box>
                                    ) : (
                                        Object.keys(groupedCourses).map((level) => {
                                            const levelCourses = groupedCourses[level];
                                            const displayedCourses = getLevelCourses(level);
                                            const isExpanded = expandedLevels[level] || false;
                                            const totalCourses = levelCourses.length;
                                            return (
                                                <Box key={level} sx={{ mb: 4 }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, bgcolor: 'white', p: 1.5, borderRadius: 2, flexWrap: 'wrap', gap: 1 }}>
                                                        <LevelIcon sx={{ mr: 1, color: 'primary.main' }} />
                                                        <Typography variant="h6" fontWeight="bold" color="primary">{level}</Typography>
                                                        <Chip label={`${totalCourses} course${totalCourses > 1 ? 's' : ''}`} size="small" sx={{ ml: 2 }} />
                                                        {hasMoreCourses(level) && (
                                                            <Button size="small" variant="text" onClick={() => toggleLevelExpanded(level)} sx={{ ml: 2 }}>
                                                                {isExpanded ? 'Show Less' : `Show All ${totalCourses}`}
                                                            </Button>
                                                        )}
                                                    </Box>
                                                    <Grid container spacing={3}>
                                                        {displayedCourses.map((course) => renderCourseCard(course))}
                                                    </Grid>
                                                </Box>
                                            );
                                        })
                                    )}
                                </DialogContent>
                                <DialogActions sx={{ p: 2, bgcolor: 'white' }}>
                                    <Button onClick={handleCloseCoursePopup} color="secondary" variant="outlined">Cancel</Button>
                                </DialogActions>
                            </Dialog>

                            {/* STATUS DROPDOWN */}
                            <Grid item xs={12}>
                                <Paper elevation={2} sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 2 }}>
                                    <Typography variant="subtitle2" fontWeight="bold" gutterBottom>Training Status</Typography>
                                    <FormControl fullWidth error={!!formErrors.status} required>
                                        <InputLabel>Status</InputLabel>
                                        <Select name="status" value={trainingData.status} label="Status" onChange={handleChange} disabled={loader}>
                                            {STATUS_OPTIONS.map((option) => (
                                                <MenuItem key={option.value} value={option.value} sx={{ '&:hover': { bgcolor: option.bgColor } }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
                                                        <Box sx={{ color: option.color, display: 'flex', alignItems: 'center' }}>{option.icon}</Box>
                                                        <Box sx={{ flex: 1 }}>
                                                            <Typography variant="body2" fontWeight="bold" sx={{ color: option.color }}>{option.label}</Typography>
                                                            <Typography variant="caption" color="text.secondary">{option.description}</Typography>
                                                        </Box>
                                                    </Box>
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    {selectedStatus && (
                                        <Box sx={{ mt: 2, p: 1.5, bgcolor: selectedStatus.bgColor, borderLeft: `4px solid ${selectedStatus.color}`, borderRadius: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <Box sx={{ color: selectedStatus.color }}>{selectedStatus.icon}</Box>
                                            <Typography variant="body2" sx={{ color: selectedStatus.color }}>
                                                <strong>Status:</strong> {selectedStatus.label}
                                            </Typography>
                                        </Box>
                                    )}
                                    {trainingData.status === 'Other' && (
                                        <TextField
                                            fullWidth label="Custom Reason" name="customReason" value={trainingData.customReason}
                                            onChange={handleChange} multiline rows={2} required
                                            error={!!formErrors.customReason}
                                            helperText={formErrors.customReason || "Please specify the reason"}
                                            disabled={loader} placeholder="E.g., Trainer unavailable, etc."
                                            sx={{ mt: 2 }}
                                        />
                                    )}
                                </Paper>
                            </Grid>

                            {/* Training Mode */}
                            <Grid item xs={6}>
                                <FormControl fullWidth error={!!formErrors.trainingMode}>
                                    <InputLabel>Training Mode</InputLabel>
                                    <Select name="trainingMode" value={trainingData.trainingMode} label="Training Mode" onChange={handleChange} required disabled={loader}>
                                        <MenuItem value=""><em>Select Training Mode</em></MenuItem>
                                        {trainingModeOptions.map((mode) => (
                                            <MenuItem key={mode.id} value={mode.value}>{mode.label}</MenuItem>
                                        ))}
                                    </Select>
                                    {formErrors.trainingMode && <Typography color="error" variant="caption">{formErrors.trainingMode}</Typography>}
                                </FormControl>
                            </Grid>

                            {/* Batch Plan */}
                            <Grid item xs={6}>
                                <TextField fullWidth label="Batch Plan" name="batchPlan" type="number" value={trainingData.batchPlan} onChange={handleChange} required disabled={loader} inputProps={{ min: 0, step: 1 }} helperText="Default: 20" />
                            </Grid>

                            {/* State */}
                            <Grid item xs={6}>
                                <FormControl fullWidth error={!!formErrors.state}>
                                    <InputLabel>State</InputLabel>
                                    <Select name="state" value={trainingData.state} label="State" onChange={handleChange} required disabled={loader || showOrg1Options}>
                                        <MenuItem value=""><em>None</em></MenuItem>
                                        {stateData.map((state) => <MenuItem key={state.id} value={state.name}>{state.name}</MenuItem>)}
                                    </Select>
                                    {formErrors.state && <Typography color="error" variant="caption">{formErrors.state}</Typography>}
                                </FormControl>
                            </Grid>

                            {/* Depot */}
                            <Grid item xs={6}>
                                <FormControl fullWidth disabled={!trainingData.state || loader || showOrg1Options} error={!!formErrors.depot}>
                                    <InputLabel>Depot</InputLabel>
                                    <Select name="depot" value={trainingData.depot} label="Depot" onChange={handleChange} required>
                                        <MenuItem value=""><em>None</em></MenuItem>
                                        {depotsForState.map((depot, index) => <MenuItem key={index} value={depot}>{depot}</MenuItem>)}
                                    </Select>
                                    {formErrors.depot && <Typography color="error" variant="caption">{formErrors.depot}</Typography>}
                                </FormControl>
                            </Grid>

                            {/* Type */}
                            <Grid item xs={6}>
                                <FormControl fullWidth error={!!formErrors.type}>
                                    <InputLabel>Training Type</InputLabel>
                                    <Select name="type" value={trainingData.type} label="Training Type" onChange={handleChange} required disabled={loader}>
                                        <MenuItem value=""><em>Select Type</em></MenuItem>
                                        {typeData.map((type) => (
                                            <MenuItem key={type.id} value={type.name}>
                                                <Box sx={{ display: 'flex', alignItems: 'center' }}>{type.name}{type.icon}</Box>
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    {formErrors.type && <Typography color="error" variant="caption">{formErrors.type}</Typography>}
                                </FormControl>
                            </Grid>

                            {/* Training Days */}
                            <Grid item xs={6}>
                                <FormControl fullWidth error={!!formErrors.trainingDays}>
                                    <InputLabel>Training Days</InputLabel>
                                    <Select name="trainingDays" value={trainingData.trainingDays} label="Training Days" onChange={handleChange} required disabled={loader}>
                                        <MenuItem value=""><em>Select Days</em></MenuItem>
                                        <MenuItem value="0">Manual Date Selection</MenuItem>
                                        {trainingDayOptions.map((days) => <MenuItem key={days} value={days}>{days} Day{days > 1 ? 's' : ''}</MenuItem>)}
                                    </Select>
                                    {formErrors.trainingDays && <Typography color="error" variant="caption">{formErrors.trainingDays}</Typography>}
                                </FormControl>
                            </Grid>

                            {/* Duration */}
                            {trainingData.trainingDays !== "" && (
                                <Grid item xs={6}>
                                    <FormControl fullWidth error={!!formErrors.duration}>
                                        <InputLabel>Duration (Hours per day)</InputLabel>
                                        <Select value={selectedDuration || ''} label="Duration (Hours per day)" onChange={handleDurationChange} required disabled={loader}>
                                            <MenuItem value=""><em>Select Duration</em></MenuItem>
                                            {[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24].map((duration) => (
                                                <MenuItem key={duration} value={duration}>{duration} Hour{duration > 1 ? 's' : ''}</MenuItem>
                                            ))}
                                        </Select>
                                        {formErrors.duration && <Typography color="error" variant="caption">{formErrors.duration}</Typography>}
                                    </FormControl>
                                </Grid>
                            )}

                            {/* Assessment Type for Technical */}
                            {isTechnicalTraining && (
                                <Grid item xs={12}>
                                    <FormControl fullWidth error={!!formErrors.technicalAssessmentType}>
                                        <InputLabel>Assessment Type</InputLabel>
                                        <Select value={trainingData.technicalAssessmentType} label="Assessment Type" onChange={handleAssessmentTypeChange} required disabled={loader}>
                                            <MenuItem value=""><em>Select Assessment Type</em></MenuItem>
                                            {assessmentTypeData.map((assessment) => (
                                                <MenuItem key={assessment.id} value={assessment.name} sx={{ borderLeft: `4px solid ${assessment.color}` }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                                        <Typography sx={{ fontWeight: 'bold', mr: 2 }}>{assessment.icon} {assessment.name}</Typography>
                                                        <Typography variant="body2" color="text.secondary">{assessment.description}</Typography>
                                                    </Box>
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            )}

                            {/* Training Dates */}
                            <Grid item xs={12}>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <CalendarTodayIcon sx={{ mr: 1, color: 'primary.main' }} />
                                    <Typography variant="subtitle2">Training Dates</Typography>
                                </Box>
                            </Grid>

                            <Grid item xs={12}>
                                <Box sx={{ mb: 2, p: 2, bgcolor: '#e3f2fd', borderRadius: 1 }}>
                                    <FormControlLabel control={<Checkbox checked={trainingData.allowPreviousDates} onChange={handleAllowPreviousDatesChange} />} label="Allow Previous Dates" />
                                </Box>
                            </Grid>

                            <Grid item xs={6}>
                                <TextField fullWidth label="Training Start Date" name="trainingStartDate" type="date" value={trainingData.trainingStartDate}
                                    onChange={handleChange} InputLabelProps={{ shrink: true }} required error={!!formErrors.trainingStartDate}
                                    helperText={formErrors.trainingStartDate || ""} disabled={loader} />
                            </Grid>

                            {isManualDateSelection ? (
                                <Grid item xs={6}>
                                    <TextField fullWidth label="Training End Date" name="manualEndDate" type="date" value={trainingData.manualEndDate}
                                        onChange={handleChange} InputLabelProps={{ shrink: true }} required error={!!formErrors.manualEndDate}
                                        helperText={formErrors.manualEndDate || "Select the end date"} disabled={loader || !trainingData.trainingStartDate}
                                        inputProps={{ min: trainingData.trainingStartDate }} />
                                </Grid>
                            ) : (
                                <Grid item xs={6}>
                                    <TextField fullWidth label="Calculated End Date" value={calculatedEndDate} disabled
                                        helperText={calculatedEndDate ? "Auto-calculated" : "Select start date, days, and time slot"} />
                                </Grid>
                            )}

                            {/* Days of Week */}
                            {isManualDateSelection && trainingData.trainingStartDate && trainingData.manualEndDate && (
                                <Grid item xs={12}>
                                    <Box sx={{ p: 2, bgcolor: '#f5f5f5', borderRadius: 1 }}>
                                        <Typography variant="subtitle2" gutterBottom>Select Days of Week (Optional):</Typography>
                                        <FormGroup row>
                                            {daysOfWeek.map((day) => (
                                                <FormControlLabel key={day.id}
                                                    control={<Checkbox checked={trainingData.selectedDaysOfWeek.includes(day.id)} onChange={() => handleDaysOfWeekChange(day.id)} />}
                                                    label={day.short} />
                                            ))}
                                        </FormGroup>
                                    </Box>
                                </Grid>
                            )}

                            {/* Time Selection */}
                            {selectedDuration && trainingData.trainingStartDate && (
                                <>
                                    <Grid item xs={12}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', mt: 2, mb: 1 }}>
                                            <AccessTimeIcon sx={{ mr: 1, color: 'primary.main' }} />
                                            <Typography variant="subtitle2">Training Time Selection</Typography>
                                        </Box>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <Paper sx={{ p: 2, bgcolor: '#f5f5f5' }}>
                                            <FormControl component="fieldset" fullWidth>
                                                <FormLabel component="legend">Choose Time Selection Method</FormLabel>
                                                <RadioGroup row value={trainingData.selectedTimeMode} onChange={(e) => handleTimeModeChange(e.target.value)}>
                                                    <FormControlLabel value="preset" control={<Radio />} label="🎯 All Time Slots" />
                                                    <FormControlLabel value="range" control={<Radio />} label="📊 Pre-defined Ranges" />
                                                    <FormControlLabel value="custom" control={<Radio />} label="✏️ Custom Range" />
                                                </RadioGroup>
                                            </FormControl>
                                        </Paper>
                                    </Grid>

                                    {trainingData.selectedTimeMode === 'range' && (
                                        <Grid item xs={12}>
                                            <FormControl fullWidth sx={{ mb: 2 }}>
                                                <InputLabel>Select Time Range</InputLabel>
                                                <Select value={trainingData.selectedTimeRange} label="Select Time Range" onChange={(e) => handleTimeRangeChange(e.target.value)}>
                                                    {timeRanges.map((range) => <MenuItem key={range.id} value={range.id}>{range.label}</MenuItem>)}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    )}

                                    {availableTimeSlots.length > 0 && (
                                        <Grid item xs={12}>
                                            <FormControl fullWidth error={!!formErrors.timeSlot}>
                                                <InputLabel>Select Time Slot</InputLabel>
                                                <Select value={trainingData.selectedTimeSlot?.id || ''} label="Select Time Slot" onChange={(e) => {
                                                    const slot = availableTimeSlots.find(s => s.id === e.target.value);
                                                    handleTimeSlotChange(slot);
                                                }}>
                                                    <MenuItem value=""><em>Select Time Slot</em></MenuItem>
                                                    {availableTimeSlots.map((slot) => (
                                                        <MenuItem key={slot.id} value={slot.id}>
                                                            {trainingData.use24HourFormat 
                                                                ? `${slot.startTime24 || slot.startTime} - ${slot.endTime24 || slot.endTime}`
                                                                : slot.displayLabel
                                                            }
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                                {formErrors.timeSlot && <Typography color="error" variant="caption">{formErrors.timeSlot}</Typography>}
                                            </FormControl>
                                        </Grid>
                                    )}
                                </>
                            )}

                            {/* Selected Time Slot */}
                            {trainingData.selectedTimeSlot && (
                                <Grid item xs={12}>
                                    <Alert severity="success" icon={<CheckCircleIcon />}>
                                        <strong>Selected Time Slot:</strong> {formatTimeForDisplay(trainingData.selectedTimeSlot.startTime)} - {formatTimeForDisplay(trainingData.selectedTimeSlot.endTime)}
                                    </Alert>
                                </Grid>
                            )}

                            {/* Trainer */}
                            <Grid item xs={12}>
                                <Divider sx={{ my: 2 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <PersonIcon sx={{ mr: 1 }} />
                                        <Typography variant="subtitle1" color="primary">Select Trainer</Typography>
                                    </Box>
                                </Divider>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                                    <Typography variant="body2" color="text.secondary">Select any user as trainer</Typography>
                                    <Button size="small" startIcon={<RefreshIcon />} onClick={refreshUsers} disabled={loadingUsers}>Refresh</Button>
                                </Box>
                                <Autocomplete 
                                    options={allUsers} 
                                    getOptionLabel={(option) => `${option.name} (${option.userType || 'No Type'})`}
                                    value={allUsers.find(t => t.id === trainingData.trainerId) || null}
                                    onChange={handleTrainerChange}
                                    disabled={loader || loadingUsers}
                                    loading={loadingUsers}
                                    renderOption={(props, option) => (
                                        <ListItem {...props} key={option.id}>
                                            <ListItemText 
                                                primary={
                                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                            <PersonIcon sx={{ mr: 1, fontSize: '1rem', color: 'primary.main' }} />
                                                            <Typography variant="body1" fontWeight="bold">{option.name}</Typography>
                                                        </Box>
                                                        <Chip label={option.userType || 'No Type'} size="small" variant="outlined" />
                                                    </Box>
                                                }
                                                secondary={<><EmailIcon sx={{ fontSize: '0.8rem', mr: 0.5 }} /> {option.email}</>}
                                            />
                                        </ListItem>
                                    )}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Select Trainer" required error={!!formErrors.trainer}
                                            helperText={formErrors.trainer || (loadingUsers ? "Loading..." : `${allUsers.length} users available`)} />
                                    )}
                                />
                            </Grid>
                        </Grid>
                        
                        <Stack direction="row" spacing={2} justifyContent="flex-end" sx={{ mt: 3 }}>
                            <Button 
                                type="submit" variant="contained" color="primary"
                                disabled={loader || !trainingData.trainerId || !trainingData.selectedTimeSlot || !selectedDuration}
                                sx={{ bgcolor: selectedStatus?.color, '&:hover': { bgcolor: selectedStatus?.color, opacity: 0.9 } }}
                            >
                                {loader ? 'Creating...' : 'Create Training'}
                            </Button>
                            <Button type="button" variant="outlined" color="secondary" onClick={handleClose} disabled={loader}>
                                Cancel
                            </Button>
                        </Stack>
                    </form>
                </Box>
            </Modal>
        </LocalizationProvider>
    );
};

export default CreateTrainingModal;